/**
 * /**
 * AlgoSys API
 * 
        Asynchronous Algorithmic Trading System

        ## WebSocket Endpoints

        The API provides real-time WebSocket connections for market data and trading events:

        - **WebSocket URL**: `ws://localhost:8000/ws/v2` (development) or `wss://your-domain.com/ws/v2` (production)
        - **Protocol**: Custom envelope-based protocol with sequence tracking and recovery
        - **Supported Events**: market ticks, bars, signals, executions, system health, etc.

        ### Connection Example:
        ```javascript
        const ws = new WebSocket('ws://localhost:8000/ws/v2');
        // Subscribe to bars (canonical only: bars:<symbol>:T:<n><unit> / bars:<symbol>:X:<n>t)
        ws.send(JSON.stringify({op: 'sub', channel: 'bars:btcusdt:T:1m', snapshot: true}));
        ```

        ### Available Channels (canonical format):
        - `bars:{symbol}:{interval_id}` - Candlestick data (interval_id is `T:<n><unit>` or `X:<n>t`)
        - `ticks:{symbol}` - Real-time price ticks
        - `ticker:{symbol}` - Ticker
        - `trading.signal.{agent_id}` - Trading signals
        - `trading.execution.{agent_id}` - Order executions
        - `system.health` - System health status
        
 * Version: 0.1.0
 *
 * This file was auto-generated by Orval
 * Do not edit this file manually
 *\/
 */
import { customInstance } from './client';
export type AccountInfoMaxWithdrawAmount = string | null;

export type AccountInfoBalance = string | null;

export type AccountInfoUnrealizedPnl = string | null;

export type AccountInfoMarginUsed = string | null;

/**
 * Полная информация об аккаунте.
 */
export interface AccountInfo {
  accountType: string;
  canTrade: boolean;
  canDeposit: boolean;
  canWithdraw: boolean;
  updateTime: number;
  totalWalletBalance: string;
  availableBalance: string;
  maxWithdrawAmount?: AccountInfoMaxWithdrawAmount;
  balances: Balance[];
  positions: Position[];
  balance?: AccountInfoBalance;
  unrealizedPnl?: AccountInfoUnrealizedPnl;
  marginUsed?: AccountInfoMarginUsed;
}

export type AgentDefinitionPatchRequestName = string | null;

export type AgentDefinitionPatchRequestAutostart = boolean | null;

/**
 * Patch SSOT agent definition (name/autostart).
 */
export interface AgentDefinitionPatchRequest {
  name?: AgentDefinitionPatchRequestName;
  autostart?: AgentDefinitionPatchRequestAutostart;
}

export type AgentResponseName = string | null;

export type AgentResponseAutostart = boolean | null;

export type AgentResponseRunId = string | null;

export type AgentResponseStats = { [key: string]: unknown };

export type AgentResponseBackfillQueued = boolean | null;

export type AgentResponseBackfillError = string | null;

/**
 * Ответ с информацией об агенте.
 */
export interface AgentResponse {
  id: string;
  name?: AgentResponseName;
  symbol: string;
  interval: string;
  isRunning: boolean;
  autostart?: AgentResponseAutostart;
  runId?: AgentResponseRunId;
  stats?: AgentResponseStats;
  backfillQueued?: AgentResponseBackfillQueued;
  backfillError?: AgentResponseBackfillError;
}

export type AgentRuntimeStateResponseIndicatorBindings = {[key: string]: RuntimeBindingResponse};

export type AgentRuntimeStateResponseEffectiveParams = { [key: string]: unknown };

export type AgentRuntimeStateResponseEffectiveIndicators = {[key: string]: { [key: string]: unknown }};

export type AgentRuntimeStateResponseLastEventCursor = string | null;

export type AgentRuntimeStateResponseStateSnapshot = { [key: string]: unknown };

export type AgentRuntimeStateResponseAdaptiveMutations = { [key: string]: unknown };

export interface AgentRuntimeStateResponse {
  executionIdentity: string;
  lifecycleStatus: string;
  strategyBinding: RuntimeBindingResponse;
  indicatorBindings?: AgentRuntimeStateResponseIndicatorBindings;
  effectiveParams?: AgentRuntimeStateResponseEffectiveParams;
  effectiveIndicators?: AgentRuntimeStateResponseEffectiveIndicators;
  warmupBarsRequired?: number;
  warmupBarsCompleted?: number;
  lastEventCursor?: AgentRuntimeStateResponseLastEventCursor;
  lastWatermarkTsMs?: number;
  stateSchemaVersion?: string;
  stateSnapshot?: AgentRuntimeStateResponseStateSnapshot;
  adaptiveMutations?: AgentRuntimeStateResponseAdaptiveMutations;
}

export type AgentSummaryStartDate = string | null;

/**
 * Сводка по агенту.
 */
export interface AgentSummary {
  agentId: string;
  timeframe: string;
  startDate?: AgentSummaryStartDate;
  endDate: string;
  metrics: Metrics;
}

export type AiArtifactV1MessageId = string | null;

export type AiArtifactV1Kind = typeof AiArtifactV1Kind[keyof typeof AiArtifactV1Kind];


 
export const AiArtifactV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type AiArtifactV1Status = typeof AiArtifactV1Status[keyof typeof AiArtifactV1Status];


 
export const AiArtifactV1Status = {
  DRAFT: 'DRAFT',
  VALID: 'VALID',
  FAILED: 'FAILED',
  SAVED: 'SAVED',
} as const;

export type AiArtifactV1SpecId = string | null;

export type AiArtifactV1Version = string | null;

export type AiArtifactV1Digest = string | null;

export type AiArtifactV1ValidationResultAnyOf = { [key: string]: unknown };

export type AiArtifactV1ValidationResult = AiArtifactV1ValidationResultAnyOf | null;

export type AiArtifactV1CreatedAt = string | null;

export type AiArtifactV1UpdatedAt = string | null;

export interface AiArtifactV1 {
  id: string;
  sessionId: string;
  messageId?: AiArtifactV1MessageId;
  kind: AiArtifactV1Kind;
  displayName: string;
  sourceCode: string;
  status: AiArtifactV1Status;
  specId?: AiArtifactV1SpecId;
  version?: AiArtifactV1Version;
  digest?: AiArtifactV1Digest;
  validationResult?: AiArtifactV1ValidationResult;
  createdAt?: AiArtifactV1CreatedAt;
  updatedAt?: AiArtifactV1UpdatedAt;
}

export type AiChatMessageCreateRequestV1TargetName = string | null;

export type AiChatMessageCreateRequestV1ReferenceIndicatorRefs = ReferenceIndicatorRefV1[] | null;

export interface AiChatMessageCreateRequestV1 {
  /**
   * @minLength 1
   * @maxLength 32000
   */
  content: string;
  targetName?: AiChatMessageCreateRequestV1TargetName;
  referenceIndicatorRefs?: AiChatMessageCreateRequestV1ReferenceIndicatorRefs;
}

export type AiChatMessageResponseV1Artifact = AiArtifactV1 | null;

export type AiChatMessageResponseV1OpenaiError = string | null;

export interface AiChatMessageResponseV1 {
  requestId: string;
  assistantMessage: AiMessageV1;
  artifact?: AiChatMessageResponseV1Artifact;
  openaiError?: AiChatMessageResponseV1OpenaiError;
}

export type AiChatSessionCreateRequestV1Kind = typeof AiChatSessionCreateRequestV1Kind[keyof typeof AiChatSessionCreateRequestV1Kind];


 
export const AiChatSessionCreateRequestV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type AiChatSessionCreateRequestV1TargetName = string | null;

export type AiChatSessionCreateRequestV1BaseSpecRef = BaseSpecRefV1 | null;

export type AiChatSessionCreateRequestV1ReferenceIndicatorRef = ReferenceIndicatorRefV1 | null;

export type AiChatSessionCreateRequestV1ReferenceIndicatorRefs = ReferenceIndicatorRefV1[] | null;

export interface AiChatSessionCreateRequestV1 {
  kind: AiChatSessionCreateRequestV1Kind;
  /** @maxLength 512 */
  title?: string;
  targetName?: AiChatSessionCreateRequestV1TargetName;
  baseSpecRef?: AiChatSessionCreateRequestV1BaseSpecRef;
  referenceIndicatorRef?: AiChatSessionCreateRequestV1ReferenceIndicatorRef;
  referenceIndicatorRefs?: AiChatSessionCreateRequestV1ReferenceIndicatorRefs;
}

export type AiChatSessionResponseV1Session = { [key: string]: unknown };

export interface AiChatSessionResponseV1 {
  requestId: string;
  session: AiChatSessionResponseV1Session;
}

export type AiContractResponseV1Kind = typeof AiContractResponseV1Kind[keyof typeof AiContractResponseV1Kind];


 
export const AiContractResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export interface AiContractResponseV1 {
  requestId: string;
  kind: AiContractResponseV1Kind;
  contract: string;
  promptTemplate: string;
}

export type AiMessageV1Model = string | null;

export type AiMessageV1TokenUsageAnyOf = { [key: string]: unknown };

export type AiMessageV1TokenUsage = AiMessageV1TokenUsageAnyOf | null;

export type AiMessageV1ValidationSummaryAnyOf = { [key: string]: unknown };

export type AiMessageV1ValidationSummary = AiMessageV1ValidationSummaryAnyOf | null;

export type AiMessageV1CreatedAt = string | null;

export interface AiMessageV1 {
  id: string;
  sessionId: string;
  role: string;
  content: string;
  model?: AiMessageV1Model;
  tokenUsage?: AiMessageV1TokenUsage;
  validationSummary?: AiMessageV1ValidationSummary;
  createdAt?: AiMessageV1CreatedAt;
}

export type AiPublishArtifactRequestV1PublishName = string | null;

export interface AiPublishArtifactRequestV1 {
  publishName?: AiPublishArtifactRequestV1PublishName;
}

export interface AiPublishArtifactResponseV1 {
  requestId: string;
  artifact: AiArtifactV1;
}

export interface AiStatusResponseV1 {
  requestId: string;
  enabled: boolean;
  configured: boolean;
}

export type AuditEventItemV1Payload = { [key: string]: unknown };

export interface AuditEventItemV1 {
  ts: string;
  event: string;
  kind: string;
  specId: string;
  version: string;
  requestId?: string;
  payload?: AuditEventItemV1Payload;
}

export type AuditEventsResponseV1Kind = typeof AuditEventsResponseV1Kind[keyof typeof AuditEventsResponseV1Kind];


 
export const AuditEventsResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export interface AuditEventsResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: AuditEventsResponseV1Kind;
  specId: string;
  version: string;
  items?: AuditEventItemV1[];
}

export type BacktestListResponseEndTime = string | null;

export type BacktestListResponseTotalReturn = number | null;

export type BacktestListResponseTotalTrades = number | null;

/**
 * Элемент списка бэктестов.
 */
export interface BacktestListResponse {
  backtestId: string;
  symbol: string;
  status: string;
  startTime: string;
  endTime?: BacktestListResponseEndTime;
  totalReturn?: BacktestListResponseTotalReturn;
  totalTrades?: BacktestListResponseTotalTrades;
}

/**
 * Глубина истории для backfill при старте сессии (Session START); Lake→Kafka→ClickHouse.
 */
export type BacktestOptimizeRequestHistoryLookbackHours = number | null;

/**
 * Parameter space definition
 */
export type BacktestOptimizeRequestParameterSpace = { [key: string]: unknown };

/**
 * Optimization algorithm (random, grid, bayesian)
 */
export type BacktestOptimizeRequestAlgorithm = string | null;

/**
 * Objective profile (balanced, profit, low_drawdown, high_sharpe)
 */
export type BacktestOptimizeRequestObjectiveProfile = string | null;

export type BacktestOptimizeRequestObjectiveWeightsAnyOf = {[key: string]: number};

/**
 * Custom objective weights
 */
export type BacktestOptimizeRequestObjectiveWeights = BacktestOptimizeRequestObjectiveWeightsAnyOf | null;

/**
 * Objective constraints
 */
export type BacktestOptimizeRequestConstraints = { [key: string]: unknown };

/**
 * Random seed
 */
export type BacktestOptimizeRequestRandomSeed = number | null;

/**
 * Optional resolved payload digest
 */
export type BacktestOptimizeRequestResolvedDigest = string | null;

/**
 * Request to run parameter optimization.
 */
export interface BacktestOptimizeRequest {
  /** Trading symbol */
  symbol: string;
  /** Start date */
  startDate: string;
  /** End date */
  endDate: string;
  /** Глубина истории для backfill при старте сессии (Session START); Lake→Kafka→ClickHouse. */
  historyLookbackHours?: BacktestOptimizeRequestHistoryLookbackHours;
  /** Strategy type */
  strategyType: string;
  /** Parameter space definition */
  parameterSpace: BacktestOptimizeRequestParameterSpace;
  /** Optimization algorithm (random, grid, bayesian) */
  algorithm?: BacktestOptimizeRequestAlgorithm;
  /**
   * Maximum iterations
   * @minimum 1
   * @maximum 1000
   */
  maxIterations?: number;
  /**
   * Number of parallel workers
   * @minimum 1
   * @maximum 10
   */
  parallelWorkers?: number;
  /** Objective profile (balanced, profit, low_drawdown, high_sharpe) */
  objectiveProfile?: BacktestOptimizeRequestObjectiveProfile;
  /** Custom objective weights */
  objectiveWeights?: BacktestOptimizeRequestObjectiveWeights;
  /** Objective constraints */
  constraints?: BacktestOptimizeRequestConstraints;
  /** Bar interval_id (канон): T:<n><unit> / X:<n>t */
  barInterval?: string;
  /** Bar source */
  barSource?: string;
  /** Initial balance */
  initialBalance?: number;
  /** Commission per trade */
  commissionPerTrade?: number;
  /** Slippage model */
  slippageModel?: string;
  /** Slippage value */
  slippageValue?: number;
  /** Enable transaction costs */
  enableTransactionCosts?: boolean;
  /** Random seed */
  randomSeed?: BacktestOptimizeRequestRandomSeed;
  /**
   * Strategy spec id (SSOT)
   * @minLength 1
   */
  strategySpecId: string;
  /**
   * Strategy spec version (immutable)
   * @minLength 1
   */
  strategySpecVersion: string;
  /** Optional resolved payload digest */
  resolvedDigest?: BacktestOptimizeRequestResolvedDigest;
  /**
   * Walk-forward folds count (1 = disabled)
   * @minimum 1
   * @maximum 64
   */
  folds?: number;
}

/**
 * Глубина истории для backfill при старте сессии (Session START); Lake→Kafka→ClickHouse.
 */
export type BacktestRequestHistoryLookbackHours = number | null;

/**
 * Immutable strategy spec ref: {spec_id, version, digest}
 */
export type BacktestRequestStrategySpec = {[key: string]: string};

/**
 * Request to run a backtest.
 */
export interface BacktestRequest {
  symbol: string;
  startDate: string;
  endDate: string;
  /** Глубина истории для backfill при старте сессии (Session START); Lake→Kafka→ClickHouse. */
  historyLookbackHours?: BacktestRequestHistoryLookbackHours;
  /** SSOT StrategyConfig (params + indicators) */
  strategyConfig?: StrategyConfigRequest;
  /** Immutable strategy spec ref: {spec_id, version, digest} */
  strategySpec: BacktestRequestStrategySpec;
  /** Начальный баланс для бэктестинга */
  initialBalance?: number;
  /** Комиссия на сделку */
  commissionPerTrade?: number;
  /** Модель проскальзывания */
  slippageModel?: string;
  /** Величина проскальзывания */
  slippageValue?: number;
}

/**
 * Response from backtest operation.
 */
export interface BacktestResponse {
  backtestId: string;
  status: string;
  message: string;
}

export type BacktestResultResponseEndTime = string | null;

export type BacktestResultResponseDurationSeconds = number | null;

/**
 * Сообщение об ошибке при status=failed
 */
export type BacktestResultResponseErrorMessage = string | null;

export type BacktestResultResponseTotalReturn = number | null;

export type BacktestResultResponseTotalTrades = number | null;

export type BacktestResultResponseWinRate = number | null;

export type BacktestResultResponseMaxDrawdown = number | null;

export type BacktestResultResponseSharpeRatio = number | null;

/**
 * Backtest result response.
 */
export interface BacktestResultResponse {
  backtestId: string;
  status: string;
  startTime: string;
  endTime?: BacktestResultResponseEndTime;
  durationSeconds?: BacktestResultResponseDurationSeconds;
  /** Сообщение об ошибке при status=failed */
  errorMessage?: BacktestResultResponseErrorMessage;
  totalReturn?: BacktestResultResponseTotalReturn;
  totalTrades?: BacktestResultResponseTotalTrades;
  winRate?: BacktestResultResponseWinRate;
  maxDrawdown?: BacktestResultResponseMaxDrawdown;
  sharpeRatio?: BacktestResultResponseSharpeRatio;
}

/**
 * Информация о балансе актива.
 */
export interface Balance {
  asset: string;
  free: string;
  locked: string;
  total: string;
}

export type BaseSpecRefV1Kind = 'indicator' | 'strategy' | null;

export interface BaseSpecRefV1 {
  /**
   * @minLength 1
   * @maxLength 128
   */
  specId: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  version: string;
  kind?: BaseSpecRefV1Kind;
}

export type BrokerCreateRequestInitialBalanceAnyOf = {[key: string]: number};

export type BrokerCreateRequestInitialBalance = BrokerCreateRequestInitialBalanceAnyOf | null;

export type BrokerCreateRequestInitialUsdt = number | null;

export type BrokerCreateRequestLeverage = number | null;

export type BrokerCreateRequestMarginType = string | null;

export type BrokerCreateRequestPositionMode = string | null;

export type BrokerCreateRequestCommissionRate = number | null;

export type BrokerCreateRequestApiKey = string | null;

export type BrokerCreateRequestApiSecret = string | null;

export type BrokerCreateRequestTestnet = boolean | null;

/**
 * Запрос на создание брокера.
 */
export interface BrokerCreateRequest {
  type: string;
  initialBalance?: BrokerCreateRequestInitialBalance;
  initialUsdt?: BrokerCreateRequestInitialUsdt;
  leverage?: BrokerCreateRequestLeverage;
  marginType?: BrokerCreateRequestMarginType;
  positionMode?: BrokerCreateRequestPositionMode;
  commissionRate?: BrokerCreateRequestCommissionRate;
  apiKey?: BrokerCreateRequestApiKey;
  apiSecret?: BrokerCreateRequestApiSecret;
  testnet?: BrokerCreateRequestTestnet;
}

export type BrokerInstanceConfig = { [key: string]: unknown };

/**
 * Информация о созданном брокере.
 */
export interface BrokerInstance {
  brokerId: string;
  type: string;
  status: string;
  createdAt: string;
  config: BrokerInstanceConfig;
}

/**
 * CPU информация.
 */
export interface Cpu {
  usagePercent: number;
  count: number;
}

export type CalculateIndicatorBatchItemParams = { [key: string]: unknown };

export type CalculateIndicatorBatchItemStateAnyOf = { [key: string]: unknown };

export type CalculateIndicatorBatchItemState = CalculateIndicatorBatchItemStateAnyOf | null;

export interface CalculateIndicatorBatchItem {
  name: string;
  params?: CalculateIndicatorBatchItemParams;
  state?: CalculateIndicatorBatchItemState;
}

export type CalculateIndicatorRequestParams = { [key: string]: unknown };

export type CalculateIndicatorRequestStateAnyOf = { [key: string]: unknown };

export type CalculateIndicatorRequestState = CalculateIndicatorRequestStateAnyOf | null;

export interface CalculateIndicatorRequest {
  bars: IndicatorBarRequest[];
  params?: CalculateIndicatorRequestParams;
  state?: CalculateIndicatorRequestState;
}

export interface CalculateIndicatorsBatchRequest {
  bars: IndicatorBarRequest[];
  indicators: CalculateIndicatorBatchItem[];
}

export type CancelOrderRequestSymbol = string | null;

/**
 * Запрос на отмену ордера.
 */
export interface CancelOrderRequest {
  clientOrderId: string;
  symbol?: CancelOrderRequestSymbol;
}

export interface CatalogItemV1 {
  specId: string;
  version: string;
  name: string;
  description: string;
  status: string;
  runtimeInterface: string;
}

export type CatalogResponseV1Kind = typeof CatalogResponseV1Kind[keyof typeof CatalogResponseV1Kind];


 
export const CatalogResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export interface CatalogResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: CatalogResponseV1Kind;
  status: string;
  items?: CatalogItemV1[];
}

export interface CodeSourceV1 {
  sourceCode?: string;
  entrypoint?: string;
  dependencies?: string[];
  language?: 'python';
}

/**
 * Request for comparing optimization runs.
 */
export interface CompareOptimizationsRequest {
  /**
   * @minItems 2
   * @maxItems 20
   */
  optimizationIds: string[];
  /** Include fold-level walk-forward details */
  includeWalkForward?: boolean;
}

export type CompareOptimizationsResponseCompatibilityGroup = { [key: string]: unknown };

export type CompareOptimizationsResponseRunsItem = { [key: string]: unknown };

/**
 * Response with compatibility-safe optimization comparison.
 */
export interface CompareOptimizationsResponse {
  compatibilityGroupKey: string;
  compatibilityGroup?: CompareOptimizationsResponseCompatibilityGroup;
  runs?: CompareOptimizationsResponseRunsItem[];
}

export type CompletedTradeResponseStrategy = string | null;

export type CompletedTradeResponseSignalId = string | null;

export type CompletedTradeResponseBarsHeld = number | null;

export type CompletedTradeResponseMae = number | null;

export type CompletedTradeResponseMfe = number | null;

export type CompletedTradeResponseMaePercent = number | null;

export type CompletedTradeResponseMfePercent = number | null;

export type CompletedTradeResponseEntryCommission = number | null;

export type CompletedTradeResponseExitCommission = number | null;

export type CompletedTradeResponseAvgEntryPrice = number | null;

export type CompletedTradeResponsePnlPercent = number | null;

export type CompletedTradeResponseIndicatorsEntryAnyOf = { [key: string]: unknown };

export type CompletedTradeResponseIndicatorsEntry = CompletedTradeResponseIndicatorsEntryAnyOf | null;

export type CompletedTradeResponseIndicatorsExitAnyOf = { [key: string]: unknown };

export type CompletedTradeResponseIndicatorsExit = CompletedTradeResponseIndicatorsExitAnyOf | null;

export type CompletedTradeResponseMetadataAnyOf = { [key: string]: unknown };

export type CompletedTradeResponseMetadata = CompletedTradeResponseMetadataAnyOf | null;

/**
 * Ответ для завершенной сделки.
 */
export interface CompletedTradeResponse {
  id: string;
  agentId: string;
  symbol: string;
  side: string;
  quantity: number;
  entryPrice: number;
  exitPrice: number;
  pnl: number;
  commission: number;
  durationMinutes: number;
  strategy?: CompletedTradeResponseStrategy;
  signalId?: CompletedTradeResponseSignalId;
  entryTime: string;
  exitTime: string;
  barsHeld?: CompletedTradeResponseBarsHeld;
  mae?: CompletedTradeResponseMae;
  mfe?: CompletedTradeResponseMfe;
  maePercent?: CompletedTradeResponseMaePercent;
  mfePercent?: CompletedTradeResponseMfePercent;
  entryCommission?: CompletedTradeResponseEntryCommission;
  exitCommission?: CompletedTradeResponseExitCommission;
  avgEntryPrice?: CompletedTradeResponseAvgEntryPrice;
  pnlPercent?: CompletedTradeResponsePnlPercent;
  indicatorsEntry?: CompletedTradeResponseIndicatorsEntry;
  indicatorsExit?: CompletedTradeResponseIndicatorsExit;
  metadata?: CompletedTradeResponseMetadata;
}

export interface DeprecateSpecRequestV1 {
  /**
   * @minLength 1
   * @maxLength 1024
   */
  reason: string;
  /** Allow deprecation even when active runtime references are detected. */
  force?: boolean;
}

export type DeprecateSpecResponseV1Kind = typeof DeprecateSpecResponseV1Kind[keyof typeof DeprecateSpecResponseV1Kind];


 
export const DeprecateSpecResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export interface DeprecateSpecResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: DeprecateSpecResponseV1Kind;
  specId: string;
  version: string;
  status: 'DEPRECATED';
  activeRefsCount?: number;
  activeRefs?: string[];
}

export type DerivativesSnapshotIngestRequestExchange = string | null;

export type DerivativesSnapshotIngestRequestOpenInterest = number | null;

export type DerivativesSnapshotIngestRequestFundingRate = number | null;

export type DerivativesSnapshotIngestRequestLongShortRatio = number | null;

export type DerivativesSnapshotIngestRequestLiquidationBuy = number | null;

export type DerivativesSnapshotIngestRequestLiquidationSell = number | null;

/**
 * Снимок деривативных метрик.
 */
export interface DerivativesSnapshotIngestRequest {
  symbol: string;
  eventTsMs: number;
  exchange?: DerivativesSnapshotIngestRequestExchange;
  openInterest?: DerivativesSnapshotIngestRequestOpenInterest;
  fundingRate?: DerivativesSnapshotIngestRequestFundingRate;
  longShortRatio?: DerivativesSnapshotIngestRequestLongShortRatio;
  liquidationBuy?: DerivativesSnapshotIngestRequestLiquidationBuy;
  liquidationSell?: DerivativesSnapshotIngestRequestLiquidationSell;
}

/**
 * Информация о диске.
 */
export interface Disk {
  totalGb: number;
  freeGb: number;
  usedPercent: number;
}

export interface DraftRequestV1 {
  /**
   * @minLength 1
   * @maxLength 128
   */
  specId: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  version?: string;
  /** @maxLength 255 */
  name?: string;
  description?: string;
}

export type DraftResponseV1Kind = typeof DraftResponseV1Kind[keyof typeof DraftResponseV1Kind];


 
export const DraftResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type DraftResponseV1DraftSpec = { [key: string]: unknown };

export interface DraftResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: DraftResponseV1Kind;
  draftSpec: DraftResponseV1DraftSpec;
  editorBundle: EditorBundleV1;
}

export type EditorBundleV1Kind = typeof EditorBundleV1Kind[keyof typeof EditorBundleV1Kind];


 
export const EditorBundleV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type EditorBundleV1Contract = { [key: string]: unknown };

export type EditorBundleV1DependencyRules = { [key: string]: unknown };

export interface EditorBundleV1 {
  schemaVersion?: string;
  kind: EditorBundleV1Kind;
  specId: string;
  version: string;
  contract?: EditorBundleV1Contract;
  scaffold?: string;
  testsTemplate?: string[];
  dependencyRules?: EditorBundleV1DependencyRules;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export type HealthCheckChecks = {[key: string]: boolean};

export type HealthCheckUptime = number | null;

/**
 * Проверка здоровья системы.
 */
export interface HealthCheck {
  status: string;
  version: string;
  timestamp: string;
  checks?: HealthCheckChecks;
  uptime?: HealthCheckUptime;
}

/**
 * Один бар для расчёта индикатора (вход).
 */
export interface IndicatorBarRequest {
  symbol?: string;
  /**
   * Timestamp в миллисекундах (ts_ms)
   * @minimum 0
   */
  timestamp: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}

export type IndicatorBatchCalculationResultValuesItem = number | null;

export type IndicatorBatchCalculationResultMeta = { [key: string]: unknown };

export type IndicatorBatchCalculationResultError = string | null;

export type IndicatorBatchCalculationResultStateAnyOf = { [key: string]: unknown };

export type IndicatorBatchCalculationResultState = IndicatorBatchCalculationResultStateAnyOf | null;

export type IndicatorBatchCalculationResultPrevStateAnyOf = { [key: string]: unknown };

export type IndicatorBatchCalculationResultPrevState = IndicatorBatchCalculationResultPrevStateAnyOf | null;

export interface IndicatorBatchCalculationResult {
  indicator: string;
  values: IndicatorBatchCalculationResultValuesItem[];
  times?: number[];
  meta?: IndicatorBatchCalculationResultMeta;
  error?: IndicatorBatchCalculationResultError;
  incrementalSupported?: boolean;
  state?: IndicatorBatchCalculationResultState;
  prevState?: IndicatorBatchCalculationResultPrevState;
}

export type IndicatorCalculationResponseValuesItem = number | null;

export type IndicatorCalculationResponseMeta = { [key: string]: unknown };

export type IndicatorCalculationResponseStateAnyOf = { [key: string]: unknown };

export type IndicatorCalculationResponseState = IndicatorCalculationResponseStateAnyOf | null;

export type IndicatorCalculationResponsePrevStateAnyOf = { [key: string]: unknown };

export type IndicatorCalculationResponsePrevState = IndicatorCalculationResponsePrevStateAnyOf | null;

/**
 * Результат расчёта индикатора. values может содержать null для NaN (первые period-1 точек RSI и др.).
 */
export interface IndicatorCalculationResponse {
  indicator: string;
  values: IndicatorCalculationResponseValuesItem[];
  times?: number[];
  meta?: IndicatorCalculationResponseMeta;
  incrementalSupported?: boolean;
  state?: IndicatorCalculationResponseState;
  prevState?: IndicatorCalculationResponsePrevState;
}

export type IndicatorMetadataResponseParamsSchema = { [key: string]: unknown };

export type IndicatorMetadataResponseOutputsSchema = { [key: string]: unknown };

/**
 * Метаданные индикатора для UI (реестр).
 */
export interface IndicatorMetadataResponse {
  name: string;
  displayName: string;
  description?: string;
  category?: string;
  categoryDisplay?: string;
  overlay?: boolean;
  paramsSchema?: IndicatorMetadataResponseParamsSchema;
  outputsSchema?: IndicatorMetadataResponseOutputsSchema;
}

export type IndicatorOutputV1OutputType = typeof IndicatorOutputV1OutputType[keyof typeof IndicatorOutputV1OutputType];


 
export const IndicatorOutputV1OutputType = {
  series: 'series',
  scalar: 'scalar',
  meta: 'meta',
} as const;

export interface IndicatorOutputV1 {
  /**
   * @minLength 1
   * @maxLength 128
   */
  key: string;
  /**
   * @minLength 1
   * @maxLength 256
   */
  label: string;
  outputType?: IndicatorOutputV1OutputType;
}

export type IndicatorSpecV1Status = typeof IndicatorSpecV1Status[keyof typeof IndicatorSpecV1Status];


 
export const IndicatorSpecV1Status = {
  DRAFT: 'DRAFT',
  READY: 'READY',
  FAILED: 'FAILED',
  DEPRECATED: 'DEPRECATED',
} as const;

export type IndicatorSpecV1StateSchema = { [key: string]: unknown };

export type IndicatorSpecV1InputContract = { [key: string]: unknown };

export type IndicatorSpecV1WarmupContract = { [key: string]: unknown };

export type IndicatorSpecV1TemporalPolicy = { [key: string]: unknown };

export type IndicatorSpecV1ModeCompatibility = { [key: string]: unknown };

export interface IndicatorSpecV1 {
  schemaVersion?: string;
  kind?: 'indicator';
  /**
   * @minLength 1
   * @maxLength 128
   */
  specId: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  version: string;
  /** @maxLength 255 */
  name?: string;
  description?: string;
  status?: IndicatorSpecV1Status;
  runtimeInterface?: 'IndicatorV1';
  /** @minimum 0 */
  warmupBars?: number;
  /** @minimum 1 */
  stateSchemaVersion?: number;
  runtimeKind?: string;
  stateSchema?: IndicatorSpecV1StateSchema;
  inputContract?: IndicatorSpecV1InputContract;
  warmupContract?: IndicatorSpecV1WarmupContract;
  temporalPolicy?: IndicatorSpecV1TemporalPolicy;
  modeCompatibility?: IndicatorSpecV1ModeCompatibility;
  paramDefinitions?: ParamDefinitionV1[];
  outputs?: IndicatorOutputV1[];
  code?: CodeSourceV1;
}

export interface IndicatorsBatchCalculationResponse {
  results?: IndicatorBatchCalculationResult[];
}

/**
 * Тип интервала (derived from interval_id)
 */
export type IntervalConfigKind = typeof IntervalConfigKind[keyof typeof IntervalConfigKind];


 
export const IntervalConfigKind = {
  tick: 'tick',
  time: 'time',
} as const;

/**
 * Конфигурация интервала для символа.
 */
export interface IntervalConfig {
  /** Канонический ID интервала (например, 'T:5m', 'X:500t') */
  interval_id: string;
  /** Тип интервала (derived from interval_id) */
  kind: IntervalConfigKind;
  /** Включен ли интервал */
  enabled?: boolean;
  /** Приоритет (меньше = выше приоритет) */
  priority?: number;
  /** time: N, tick: ticks_per_bar */
  value?: number;
  /** time: длительность окна в ms; tick: 0 */
  duration_ms?: number;
}

/**
 * Запрос на установку плеча.
 */
export interface LeverageRequest {
  /**
   * Символ для установки плеча
   * @minLength 1
   */
  symbol: string;
  /**
   * Плечо (1-125)
   * @minimum 1
   * @maximum 125
   */
  leverage: number;
}

/**
 * Запрос на установку типа маржи.
 */
export interface MarginTypeRequest {
  /**
   * Символ для установки типа маржи
   * @minLength 1
   */
  symbol: string;
  /**
   * Тип маржи: ISOLATED/CROSS или isolated/cross (case-insensitive)
   * @pattern ^(ISOLATED|CROSS|isolated|cross)$
   */
  marginType: string;
}

export type MarketBarResponseCloseTime = number | null;

/**
 * Один бар данных.
 */
export interface MarketBarResponse {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  closeTime?: MarketBarResponseCloseTime;
}

export type MarketCalendarEventIngestRequestSymbolScope = string | null;

export type MarketCalendarEventIngestRequestVenue = string | null;

export type MarketCalendarEventIngestRequestEndTsMs = number | null;

export type MarketCalendarEventIngestRequestSeverity = string | null;

export type MarketCalendarEventIngestRequestTitle = string | null;

export type MarketCalendarEventIngestRequestPayload = { [key: string]: unknown };

/**
 * Загрузка события календаря в in-memory репозиторий (+ опционально Kafka).
 */
export interface MarketCalendarEventIngestRequest {
  eventId: string;
  symbolScope?: MarketCalendarEventIngestRequestSymbolScope;
  venue?: MarketCalendarEventIngestRequestVenue;
  eventType?: string;
  source?: string;
  startTsMs: number;
  endTsMs?: MarketCalendarEventIngestRequestEndTsMs;
  severity?: MarketCalendarEventIngestRequestSeverity;
  title?: MarketCalendarEventIngestRequestTitle;
  payload?: MarketCalendarEventIngestRequestPayload;
}

export type MarketChartFactResponseFactKind = typeof MarketChartFactResponseFactKind[keyof typeof MarketChartFactResponseFactKind];


 
export const MarketChartFactResponseFactKind = {
  signal: 'signal',
  fill: 'fill',
  trade_open: 'trade_open',
  trade_close: 'trade_close',
  open_position: 'open_position',
} as const;

export type MarketChartFactResponseBarTimeRelation = typeof MarketChartFactResponseBarTimeRelation[keyof typeof MarketChartFactResponseBarTimeRelation];


 
export const MarketChartFactResponseBarTimeRelation = {
  exact: 'exact',
  floor_open: 'floor_open',
} as const;

export type MarketChartFactResponseSignalId = string | null;

export type MarketChartFactResponseTradeId = string | null;

export type MarketChartFactResponseSide = string | null;

export type MarketChartFactResponsePrice = number | null;

export type MarketChartFactResponseQuantity = number | null;

export type MarketChartFactResponseReason = string | null;

export type MarketChartFactResponseTitle = string | null;

export type MarketChartFactResponseStatus = string | null;

export type MarketChartFactResponseMetadataAnyOf = { [key: string]: unknown };

export type MarketChartFactResponseMetadata = MarketChartFactResponseMetadataAnyOf | null;

/**
 * Единый chart-scoped backend fact item.
 */
export interface MarketChartFactResponse {
  id: string;
  factKind: MarketChartFactResponseFactKind;
  symbol: string;
  barTime: number;
  eventTime: number;
  barTimeRelation: MarketChartFactResponseBarTimeRelation;
  signalId?: MarketChartFactResponseSignalId;
  tradeId?: MarketChartFactResponseTradeId;
  side?: MarketChartFactResponseSide;
  price?: MarketChartFactResponsePrice;
  quantity?: MarketChartFactResponseQuantity;
  reason?: MarketChartFactResponseReason;
  title?: MarketChartFactResponseTitle;
  status?: MarketChartFactResponseStatus;
  source: string;
  metadata?: MarketChartFactResponseMetadata;
}

export type MarketChartFactsResponseRuntimeProjection = TradingRuntimeProjectionResponse | null;

/**
 * Единый ответ для chart fact model.
 */
export interface MarketChartFactsResponse {
  symbol: string;
  interval: string;
  count: number;
  bars: MarketBarResponse[];
  indicatorSeries?: IndicatorBatchCalculationResult[];
  signalFacts?: MarketChartFactResponse[];
  tradeFacts?: MarketChartFactResponse[];
  tradeSegments?: MarketTradeSegmentResponse[];
  runtimeProjection?: MarketChartFactsResponseRuntimeProjection;
}

/**
 * Ответ с рыночными данными.
 */
export interface MarketDataResponse {
  symbol: string;
  interval: string;
  count: number;
  bars: MarketBarResponse[];
}

export type MarketProjectionIndicatorRequestParams = { [key: string]: unknown };

export type MarketProjectionIndicatorRequestRuntimeSpecAnyOf = { [key: string]: unknown };

export type MarketProjectionIndicatorRequestRuntimeSpec = MarketProjectionIndicatorRequestRuntimeSpecAnyOf | null;

export interface MarketProjectionIndicatorRequest {
  name: string;
  params?: MarketProjectionIndicatorRequestParams;
  runtimeSpec?: MarketProjectionIndicatorRequestRuntimeSpec;
}

export type MarketProjectionRequestAgentId = string | null;

export interface MarketProjectionRequest {
  symbol: string;
  interval: string;
  bars: MarketBarResponse[];
  agentId?: MarketProjectionRequestAgentId;
  indicators?: MarketProjectionIndicatorRequest[];
}

export interface MarketProjectionResponse {
  symbol: string;
  interval: string;
  count: number;
  bars: MarketBarResponse[];
  indicatorSeries?: IndicatorBatchCalculationResult[];
}

export type MarketSnapshotTickers = {[key: string]: TickerInfo};

export type MarketSnapshotLastUpdate = number | null;

/**
 * Снимок состояния рынка для UI.
 */
export interface MarketSnapshot {
  tickers: MarketSnapshotTickers;
  activeSymbols: string[];
  timestamp: number;
  lastUpdate?: MarketSnapshotLastUpdate;
}

export type MarketTradeSegmentResponseSignalId = string | null;

export type MarketTradeSegmentResponsePnl = number | null;

export type MarketTradeSegmentResponseSide = string | null;

/**
 * Сегмент завершённой сделки для render-only слоя чарта.
 */
export interface MarketTradeSegmentResponse {
  id: string;
  tradeId: string;
  signalId?: MarketTradeSegmentResponseSignalId;
  fromTime: number;
  fromPrice: number;
  toTime: number;
  toPrice: number;
  pnl?: MarketTradeSegmentResponsePnl;
  side?: MarketTradeSegmentResponseSide;
}

/**
 * Информация о памяти.
 */
export interface Memory {
  totalGb: number;
  availableGb: number;
  usedPercent: number;
  processMb: number;
}

export type MetricsSortinoRatio = number | null;

export type MetricsMaxDrawdownDuration = number | null;

export type MetricsMaxDrawdownPct = number | null;

export type MetricsMaxDrawdownDate = string | null;

export type MetricsAvgWin = number | null;

export type MetricsAvgLoss = number | null;

export type MetricsLargestWin = number | null;

export type MetricsLargestLoss = number | null;

export type MetricsAvgHoldTime = number | null;

export type MetricsBarsPerWin = number | null;

export type MetricsBarsPerLoss = number | null;

export type MetricsTotalMfe = number | null;

export type MetricsYearlyReturn = number | null;

export type MetricsMonthlyReturn = number | null;

export type MetricsIncomePerBar = number | null;

export type MetricsBestDay = number | null;

export type MetricsWorstDay = number | null;

export type MetricsConsecutiveWins = number | null;

export type MetricsConsecutiveLosses = number | null;

export type MetricsRecoveryFactor = number | null;

export type MetricsExpectancy = number | null;

export type MetricsGrossProfit = number | null;

export type MetricsGrossLoss = number | null;

export type MetricsTotalCommission = number | null;

export type MetricsAvgPnl = number | null;

export type MetricsAvgPnlPercent = number | null;

export type MetricsAvgWinPercent = number | null;

export type MetricsAvgLossPercent = number | null;

export type MetricsNetPnlPercent = number | null;

export type MetricsLoseRate = number | null;

export type MetricsPayoffRatio = number | null;

export interface Metrics {
  totalTrades: number;
  closedTradesCount?: number;
  fillsCount?: number;
  openPositionsCount?: number;
  winningTrades: number;
  losingTrades: number;
  winRate: number;
  profitFactor: number;
  sharpeRatio: number;
  sortinoRatio?: MetricsSortinoRatio;
  maxDrawdown: number;
  maxDrawdownDuration?: MetricsMaxDrawdownDuration;
  maxDrawdownPct?: MetricsMaxDrawdownPct;
  maxDrawdownDate?: MetricsMaxDrawdownDate;
  avgWin?: MetricsAvgWin;
  avgLoss?: MetricsAvgLoss;
  largestWin?: MetricsLargestWin;
  largestLoss?: MetricsLargestLoss;
  totalPnl: number;
  realizedPnl?: number;
  unrealizedPnl?: number;
  totalVolume: number;
  avgHoldTime?: MetricsAvgHoldTime;
  barsPerWin?: MetricsBarsPerWin;
  barsPerLoss?: MetricsBarsPerLoss;
  totalMfe?: MetricsTotalMfe;
  yearlyReturn?: MetricsYearlyReturn;
  monthlyReturn?: MetricsMonthlyReturn;
  incomePerBar?: MetricsIncomePerBar;
  bestDay?: MetricsBestDay;
  worstDay?: MetricsWorstDay;
  consecutiveWins?: MetricsConsecutiveWins;
  consecutiveLosses?: MetricsConsecutiveLosses;
  recoveryFactor?: MetricsRecoveryFactor;
  expectancy?: MetricsExpectancy;
  grossProfit?: MetricsGrossProfit;
  grossLoss?: MetricsGrossLoss;
  totalCommission?: MetricsTotalCommission;
  avgPnl?: MetricsAvgPnl;
  avgPnlPercent?: MetricsAvgPnlPercent;
  avgWinPercent?: MetricsAvgWinPercent;
  avgLossPercent?: MetricsAvgLossPercent;
  netPnlPercent?: MetricsNetPnlPercent;
  loseRate?: MetricsLoseRate;
  payoffRatio?: MetricsPayoffRatio;
}

export type OptimizationDetailResponseBestScore = number | null;

export type OptimizationDetailResponseBestParams = { [key: string]: unknown };

export type OptimizationDetailResponseBestStrategyConfig = { [key: string]: unknown };

export type OptimizationDetailResponseIterationsItem = { [key: string]: unknown };

export type OptimizationDetailResponseStartedAt = string | null;

export type OptimizationDetailResponseCompletedAt = string | null;

export type OptimizationDetailResponseAlgorithm = string | null;

export type OptimizationDetailResponseObjectiveProfile = string | null;

export type OptimizationDetailResponseObjectiveWeightsAnyOf = {[key: string]: number};

export type OptimizationDetailResponseObjectiveWeights = OptimizationDetailResponseObjectiveWeightsAnyOf | null;

export type OptimizationDetailResponseConstraints = { [key: string]: unknown };

export type OptimizationDetailResponseErrorMessage = string | null;

export type OptimizationDetailResponseOptimizationRunManifest = { [key: string]: unknown };

export type OptimizationDetailResponseWalkForwardResultsItem = { [key: string]: unknown };

export type OptimizationDetailResponseGuardrailsResult = { [key: string]: unknown };

/**
 * Detailed optimization response.
 */
export interface OptimizationDetailResponse {
  optimizationId: string;
  symbol: string;
  strategyType: string;
  startDate: string;
  endDate: string;
  status: string;
  bestScore?: OptimizationDetailResponseBestScore;
  bestParams?: OptimizationDetailResponseBestParams;
  bestStrategyConfig?: OptimizationDetailResponseBestStrategyConfig;
  iterations?: OptimizationDetailResponseIterationsItem[];
  currentIteration: number;
  totalIterations: number;
  progressPercentage: number;
  createdAt: string;
  startedAt?: OptimizationDetailResponseStartedAt;
  completedAt?: OptimizationDetailResponseCompletedAt;
  algorithm?: OptimizationDetailResponseAlgorithm;
  maxIterations: number;
  objectiveProfile?: OptimizationDetailResponseObjectiveProfile;
  objectiveWeights?: OptimizationDetailResponseObjectiveWeights;
  constraints?: OptimizationDetailResponseConstraints;
  errorMessage?: OptimizationDetailResponseErrorMessage;
  optimizationRunManifest?: OptimizationDetailResponseOptimizationRunManifest;
  walkForwardResults?: OptimizationDetailResponseWalkForwardResultsItem[];
  guardrailsResult?: OptimizationDetailResponseGuardrailsResult;
}

export type OptimizationLeaderboardResponseItemsItem = { [key: string]: unknown };

/**
 * Leaderboard response for optimization runs.
 */
export interface OptimizationLeaderboardResponse {
  items?: OptimizationLeaderboardResponseItemsItem[];
}

export type OptimizationListResponseBestScore = number | null;

export type OptimizationListResponseCompletedAt = string | null;

/**
 * Response item for optimization list.
 */
export interface OptimizationListResponse {
  optimizationId: string;
  symbol: string;
  strategyType: string;
  status: string;
  bestScore?: OptimizationListResponseBestScore;
  createdAt: string;
  completedAt?: OptimizationListResponseCompletedAt;
}

export type OptimizationProgressResponseBestScore = number | null;

export type OptimizationProgressResponseBestParams = { [key: string]: unknown };

export type OptimizationProgressResponseBestStrategyConfig = { [key: string]: unknown };

export type OptimizationProgressResponseStartedAt = string | null;

export type OptimizationProgressResponseCompletedAt = string | null;

export type OptimizationProgressResponseErrorMessage = string | null;

export type OptimizationProgressResponseOptimizationRunManifest = { [key: string]: unknown };

export type OptimizationProgressResponseWalkForwardResultsItem = { [key: string]: unknown };

export type OptimizationProgressResponseGuardrailsResult = { [key: string]: unknown };

/**
 * Response with optimization progress.
 */
export interface OptimizationProgressResponse {
  optimizationId: string;
  status: string;
  currentIteration: number;
  totalIterations: number;
  progressPercentage: number;
  bestScore?: OptimizationProgressResponseBestScore;
  bestParams?: OptimizationProgressResponseBestParams;
  bestStrategyConfig?: OptimizationProgressResponseBestStrategyConfig;
  startedAt?: OptimizationProgressResponseStartedAt;
  completedAt?: OptimizationProgressResponseCompletedAt;
  errorMessage?: OptimizationProgressResponseErrorMessage;
  optimizationRunManifest?: OptimizationProgressResponseOptimizationRunManifest;
  walkForwardResults?: OptimizationProgressResponseWalkForwardResultsItem[];
  guardrailsResult?: OptimizationProgressResponseGuardrailsResult;
}

export type OrderInfoClientOrderId = string | null;

export type OrderInfoSide = typeof OrderInfoSide[keyof typeof OrderInfoSide];


 
export const OrderInfoSide = {
  BUY: 'BUY',
  SELL: 'SELL',
} as const;

export type OrderInfoOrderType = typeof OrderInfoOrderType[keyof typeof OrderInfoOrderType];


 
export const OrderInfoOrderType = {
  MARKET: 'MARKET',
  LIMIT: 'LIMIT',
  STOP_LOSS: 'STOP_LOSS',
  STOP_LOSS_LIMIT: 'STOP_LOSS_LIMIT',
  TAKE_PROFIT: 'TAKE_PROFIT',
  TAKE_PROFIT_LIMIT: 'TAKE_PROFIT_LIMIT',
} as const;

export type OrderInfoPrice = string | null;

export type OrderInfoStopPrice = string | null;

export type OrderInfoStatus = typeof OrderInfoStatus[keyof typeof OrderInfoStatus];


 
export const OrderInfoStatus = {
  NEW: 'NEW',
  PARTIALLY_FILLED: 'PARTIALLY_FILLED',
  FILLED: 'FILLED',
  CANCELED: 'CANCELED',
  PENDING_CANCEL: 'PENDING_CANCEL',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
} as const;

export type OrderInfoTimeInForce = 'GTC' | 'IOC' | 'FOK' | null;

export type OrderInfoUpdateTime = number | null;

/**
 * Исполненное количество
 */
export type OrderInfoExecutedQty = string | null;

export type OrderInfoAvgPrice = string | null;

/**
 * Алиас для quantity
 */
export type OrderInfoOrigQty = string | null;

/**
 * Информация об ордере для API.
Унифицированная структура для API с поддержкой обоих вариантов имен (quantity/qty).
 */
export interface OrderInfo {
  /** @minLength 1 */
  orderId: string;
  clientOrderId?: OrderInfoClientOrderId;
  /**
   * @minLength 1
   * @maxLength 20
   * @pattern ^[A-Z0-9]+$
   */
  symbol: string;
  side: OrderInfoSide;
  orderType: OrderInfoOrderType;
  /** Исходное количество */
  quantity: string;
  price?: OrderInfoPrice;
  stopPrice?: OrderInfoStopPrice;
  status: OrderInfoStatus;
  timeInForce?: OrderInfoTimeInForce;
  /** */
  transactTime: number;
  updateTime?: OrderInfoUpdateTime;
  /** Исполненное количество */
  executedQty?: OrderInfoExecutedQty;
  avgPrice?: OrderInfoAvgPrice;
  /** Алиас для quantity */
  origQty?: OrderInfoOrigQty;
}

export type OrderRequestSide = typeof OrderRequestSide[keyof typeof OrderRequestSide];


 
export const OrderRequestSide = {
  BUY: 'BUY',
  SELL: 'SELL',
} as const;

export type OrderRequestOrderType = typeof OrderRequestOrderType[keyof typeof OrderRequestOrderType];


 
export const OrderRequestOrderType = {
  MARKET: 'MARKET',
  LIMIT: 'LIMIT',
  STOP: 'STOP',
  STOP_LOSS: 'STOP_LOSS',
  STOP_LIMIT: 'STOP_LIMIT',
  STOP_LOSS_LIMIT: 'STOP_LOSS_LIMIT',
  TAKE_PROFIT: 'TAKE_PROFIT',
  TAKE_PROFIT_LIMIT: 'TAKE_PROFIT_LIMIT',
} as const;

export type OrderRequestQuantity = number | string;

export type OrderRequestPriceAnyOf = number | string;

export type OrderRequestPrice = OrderRequestPriceAnyOf | null;

export type OrderRequestStopPriceAnyOf = number | string;

export type OrderRequestStopPrice = OrderRequestStopPriceAnyOf | null;

export type OrderRequestClientOrderId = string | null;

/**
 * Время жизни ордера
 */
export type OrderRequestTimeInForce = 'GTC' | 'IOC' | 'FOK' | null;

/**
 * Сторона позиции для фьючерсов
 */
export type OrderRequestPositionSide = 'LONG' | 'SHORT' | 'BOTH' | null;

/**
 * Запрос на размещение ордера.
 */
export interface OrderRequest {
  /**
   * @minLength 1
   * @maxLength 20
   * @pattern ^[A-Za-z0-9]+$
   */
  symbol: string;
  side: OrderRequestSide;
  orderType: OrderRequestOrderType;
  quantity: OrderRequestQuantity;
  price?: OrderRequestPrice;
  stopPrice?: OrderRequestStopPrice;
  clientOrderId?: OrderRequestClientOrderId;
  /** Время жизни ордера */
  timeInForce?: OrderRequestTimeInForce;
  /** Только уменьшение позиции (фьючерсы) */
  reduceOnly?: boolean;
  /** Post-only ордер (не совмещается с текущей ценой) */
  postOnly?: boolean;
  /** Сторона позиции для фьючерсов */
  positionSide?: OrderRequestPositionSide;
}

export type OrderResponseClientOrderId = string | null;

export type OrderResponseSide = typeof OrderResponseSide[keyof typeof OrderResponseSide];


 
export const OrderResponseSide = {
  BUY: 'BUY',
  SELL: 'SELL',
} as const;

export type OrderResponseOrderType = typeof OrderResponseOrderType[keyof typeof OrderResponseOrderType];


 
export const OrderResponseOrderType = {
  MARKET: 'MARKET',
  LIMIT: 'LIMIT',
  STOP_LOSS: 'STOP_LOSS',
  STOP_LOSS_LIMIT: 'STOP_LOSS_LIMIT',
  TAKE_PROFIT: 'TAKE_PROFIT',
  TAKE_PROFIT_LIMIT: 'TAKE_PROFIT_LIMIT',
} as const;

export type OrderResponsePrice = string | null;

export type OrderResponseStopPrice = string | null;

export type OrderResponseStatus = typeof OrderResponseStatus[keyof typeof OrderResponseStatus];


 
export const OrderResponseStatus = {
  NEW: 'NEW',
  PARTIALLY_FILLED: 'PARTIALLY_FILLED',
  FILLED: 'FILLED',
  CANCELED: 'CANCELED',
  PENDING_CANCEL: 'PENDING_CANCEL',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
} as const;

export type OrderResponseUpdateTime = number | null;

export type OrderResponseExecutedQty = string | null;

export type OrderResponseAvgPrice = string | null;

/**
 * Ответ на размещение ордера.
 */
export interface OrderResponse {
  /** @minLength 1 */
  orderId: string;
  clientOrderId?: OrderResponseClientOrderId;
  /**
   * @minLength 1
   * @maxLength 20
   * @pattern ^[A-Z0-9]+$
   */
  symbol: string;
  side: OrderResponseSide;
  orderType: OrderResponseOrderType;
  quantity: string;
  price?: OrderResponsePrice;
  stopPrice?: OrderResponseStopPrice;
  status: OrderResponseStatus;
  /** */
  transactTime: number;
  updateTime?: OrderResponseUpdateTime;
  executedQty?: OrderResponseExecutedQty;
  avgPrice?: OrderResponseAvgPrice;
}

export interface PaginatedResponseBacktestListResponse {
  /** Алиас для skip (обратная совместимость) */
  offset?: number;
}

export interface PaginatedResponseOptimizationListResponse {
  /** Алиас для skip (обратная совместимость) */
  offset?: number;
}

export type ParamDefinitionV1InputType = typeof ParamDefinitionV1InputType[keyof typeof ParamDefinitionV1InputType];


 
export const ParamDefinitionV1InputType = {
  number: 'number',
  percent: 'percent',
  select: 'select',
  toggle: 'toggle',
  timeframe: 'timeframe',
  money: 'money',
} as const;

export type ParamDefinitionV1Unit = string | null;

export type ParamDefinitionV1Min = number | null;

export type ParamDefinitionV1Max = number | null;

export type ParamDefinitionV1Step = number | null;

export type ParamDefinitionV1ConstraintsItem = { [key: string]: unknown };

export type ParamDefinitionV1VisibilityRulesItem = { [key: string]: unknown };

export interface ParamDefinitionV1 {
  /**
   * @minLength 1
   * @maxLength 128
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  engineKey: string;
  /**
   * English label for UI
   * @minLength 1
   * @maxLength 256
   */
  label: string;
  /** @maxLength 1024 */
  description?: string;
  inputType: ParamDefinitionV1InputType;
  unit?: ParamDefinitionV1Unit;
  min?: ParamDefinitionV1Min;
  max?: ParamDefinitionV1Max;
  step?: ParamDefinitionV1Step;
  default?: unknown;
  required?: boolean;
  advanced?: boolean;
  group?: string;
  constraints?: ParamDefinitionV1ConstraintsItem[];
  visibilityRules?: ParamDefinitionV1VisibilityRulesItem[];
}

/**
 * Данные производительности.
 */
export interface PerformanceData {
  timestamp: string;
  pnl: string;
  cumulativePnl: string;
  trades: number;
  winRate: number;
  volume: string;
}

export type PositionMarkPrice = string | null;

export type PositionRealizedPnl = string | null;

export type PositionLeverage = number | null;

export type PositionLiquidationPrice = string | null;

export type PositionMarginType = string | null;

export type PositionIsolatedMargin = string | null;

/**
 * Информация о позиции.
 */
export interface Position {
  symbol: string;
  positionSide: string;
  positionAmt: string;
  entryPrice: string;
  markPrice?: PositionMarkPrice;
  unrealizedPnl: string;
  realizedPnl?: PositionRealizedPnl;
  leverage?: PositionLeverage;
  liquidationPrice?: PositionLiquidationPrice;
  marginType?: PositionMarginType;
  isolatedMargin?: PositionIsolatedMargin;
  updateTime: number;
}

export interface QuickSaveRequestV1 {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @minLength 10 */
  code: string;
}

export type QuickSaveResponseV1Kind = typeof QuickSaveResponseV1Kind[keyof typeof QuickSaveResponseV1Kind];


 
export const QuickSaveResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type QuickSaveResponseV1Extracted = { [key: string]: unknown };

export interface QuickSaveResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: QuickSaveResponseV1Kind;
  specId: string;
  version: string;
  status: string;
  digest: string;
  extracted?: QuickSaveResponseV1Extracted;
}

/**
 * Optional indicator spec to include source in strategy AI context.
 */
export interface ReferenceIndicatorRefV1 {
  /**
   * @minLength 1
   * @maxLength 128
   */
  specId: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  version: string;
}

export type ResolvedStrategyResponseV1Resolved = { [key: string]: unknown };

export interface ResolvedStrategyResponseV1 {
  requestId: string;
  schemaVersion?: string;
  specId: string;
  version: string;
  mode: string;
  resolved?: ResolvedStrategyResponseV1Resolved;
}

export interface RuntimeBindingResponse {
  specId: string;
  version: string;
  digest: string;
  runtimeInterface: string;
  sourceCode?: string;
  entrypoint?: string;
}

export type RuntimeFillSnapshotClientOrderId = string | null;

export type RuntimeFillSnapshotCommissionAsset = string | null;

export type RuntimeFillSnapshotExchangeFillId = string | null;

/**
 * Краткое состояние fill/execution для runtime projection.
 */
export interface RuntimeFillSnapshot {
  id: string;
  orderId: string;
  clientOrderId?: RuntimeFillSnapshotClientOrderId;
  agentId: string;
  symbol: string;
  side: string;
  quantity: number;
  price: number;
  commission: number;
  commissionAsset?: RuntimeFillSnapshotCommissionAsset;
  exchangeFillId?: RuntimeFillSnapshotExchangeFillId;
  timestamp: string;
}

export type RuntimeOrderSnapshotExchangeOrderId = string | null;

export type RuntimeOrderSnapshotAvgPrice = number | null;

export type RuntimeOrderSnapshotSignalId = string | null;

export type RuntimeOrderSnapshotTimestamp = string | null;

export type RuntimeOrderSnapshotUpdatedAt = string | null;

/**
 * Краткое состояние ордера для runtime projection.
 */
export interface RuntimeOrderSnapshot {
  id: string;
  clientOrderId: string;
  exchangeOrderId?: RuntimeOrderSnapshotExchangeOrderId;
  agentId: string;
  symbol: string;
  side: string;
  orderType: string;
  status: string;
  quantity: number;
  filledQuantity: number;
  remainingQuantity: number;
  avgPrice?: RuntimeOrderSnapshotAvgPrice;
  signalId?: RuntimeOrderSnapshotSignalId;
  timestamp?: RuntimeOrderSnapshotTimestamp;
  updatedAt?: RuntimeOrderSnapshotUpdatedAt;
}

export type RuntimePositionSnapshotPositionSide = string | null;

export type RuntimePositionSnapshotEntryPrice = number | null;

export type RuntimePositionSnapshotMarkPrice = number | null;

export type RuntimePositionSnapshotCurrentPrice = number | null;

export type RuntimePositionSnapshotRealizedPnl = number | null;

export type RuntimePositionSnapshotOpenedAt = string | null;

export type RuntimePositionSnapshotClosedAt = string | null;

export type RuntimePositionSnapshotUpdatedAt = string | null;

/**
 * Краткое состояние позиции для runtime projection.
 */
export interface RuntimePositionSnapshot {
  id: string;
  agentId: string;
  symbol: string;
  side: string;
  positionSide?: RuntimePositionSnapshotPositionSide;
  size: number;
  entryPrice?: RuntimePositionSnapshotEntryPrice;
  markPrice?: RuntimePositionSnapshotMarkPrice;
  currentPrice?: RuntimePositionSnapshotCurrentPrice;
  unrealizedPnl: number;
  realizedPnl?: RuntimePositionSnapshotRealizedPnl;
  status: string;
  openedAt?: RuntimePositionSnapshotOpenedAt;
  closedAt?: RuntimePositionSnapshotClosedAt;
  updatedAt?: RuntimePositionSnapshotUpdatedAt;
}

export type RuntimeSignalSnapshotSide = string | null;

export type RuntimeSignalSnapshotSignalType = string | null;

export type RuntimeSignalSnapshotStatus = string | null;

export type RuntimeSignalSnapshotReason = string | null;

export type RuntimeSignalSnapshotPrice = number | null;

export type RuntimeSignalSnapshotQuantity = number | null;

export type RuntimeSignalSnapshotMetadataAnyOf = { [key: string]: unknown };

export type RuntimeSignalSnapshotMetadata = RuntimeSignalSnapshotMetadataAnyOf | null;

/**
 * Последний или недавний сигнал для runtime projection.
 */
export interface RuntimeSignalSnapshot {
  id: string;
  signalId: string;
  agentId: string;
  symbol: string;
  side?: RuntimeSignalSnapshotSide;
  signalType?: RuntimeSignalSnapshotSignalType;
  status?: RuntimeSignalSnapshotStatus;
  reason?: RuntimeSignalSnapshotReason;
  price?: RuntimeSignalSnapshotPrice;
  quantity?: RuntimeSignalSnapshotQuantity;
  timestamp: number;
  metadata?: RuntimeSignalSnapshotMetadata;
}

export type SaveResponseV1Kind = typeof SaveResponseV1Kind[keyof typeof SaveResponseV1Kind];


 
export const SaveResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export interface SaveResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: SaveResponseV1Kind;
  specId: string;
  version: string;
  status: string;
  digest: string;
}

export type SignalResponseSide = string | null;

export type SignalResponseDirection = string | null;

export type SignalResponsePrice = number | null;

export type SignalResponseQuantity = number | null;

export type SignalResponseReason = string | null;

export type SignalResponseEntryPrice = number | null;

export type SignalResponseStopLoss = number | null;

export type SignalResponseTakeProfit = number | null;

export type SignalResponseStrategyName = string | null;

export type SignalResponseCreatedAt = string | null;

export type SignalResponseMetadataAnyOf = { [key: string]: unknown };

export type SignalResponseMetadata = SignalResponseMetadataAnyOf | null;

/**
 * Ответ для одного сигнала.
 */
export interface SignalResponse {
  id: string;
  signalId: string;
  agentId: string;
  symbol: string;
  signalType: string;
  kind: string;
  side?: SignalResponseSide;
  direction?: SignalResponseDirection;
  confidence: number;
  price?: SignalResponsePrice;
  quantity?: SignalResponseQuantity;
  reason?: SignalResponseReason;
  entryPrice?: SignalResponseEntryPrice;
  stopLoss?: SignalResponseStopLoss;
  takeProfit?: SignalResponseTakeProfit;
  strategyName?: SignalResponseStrategyName;
  status?: string;
  timestamp: number;
  createdAt?: SignalResponseCreatedAt;
  metadata?: SignalResponseMetadata;
}

export type SimpleAgentCreateRequestStrategy = { [key: string]: unknown };

export type SimpleAgentCreateRequestIndicatorsAnyOf = { [key: string]: unknown };

export type SimpleAgentCreateRequestIndicators = SimpleAgentCreateRequestIndicatorsAnyOf | null;

/**
 * Required strategy spec reference: {spec_id, version}.
 */
export type SimpleAgentCreateRequestStrategySpec = {[key: string]: string};

/**
 * Глубина истории для backfill при старте сессии (Session START); Lake→Kafka→ClickHouse.
 */
export type SimpleAgentCreateRequestHistoryLookbackHours = number | null;

export type SimpleAgentCreateRequestTickBarsAnyOf = { [key: string]: unknown };

/**
 * Настройки тиковых баров (для тиковых интервалов)
 */
export type SimpleAgentCreateRequestTickBars = SimpleAgentCreateRequestTickBarsAnyOf | null;

/**
 * Каноничный запрос на создание агента (wire API POST /agents).
 */
export interface SimpleAgentCreateRequest {
  name: string;
  symbol: string;
  interval: string;
  strategy: SimpleAgentCreateRequestStrategy;
  indicators?: SimpleAgentCreateRequestIndicators;
  /** ID брокера (paper, binance_futures и т.д.); канонический выбор без скрытого fallback. */
  brokerId?: string;
  /** Required strategy spec reference: {spec_id, version}. */
  strategySpec: SimpleAgentCreateRequestStrategySpec;
  autostart?: boolean;
  /** Глубина истории для backfill при старте сессии (Session START); Lake→Kafka→ClickHouse. */
  historyLookbackHours?: SimpleAgentCreateRequestHistoryLookbackHours;
  /** Настройки тиковых баров (для тиковых интервалов) */
  tickBars?: SimpleAgentCreateRequestTickBars;
}

export type SpecResponseV1Kind = typeof SpecResponseV1Kind[keyof typeof SpecResponseV1Kind];


 
export const SpecResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type SpecResponseV1Spec = { [key: string]: unknown };

export interface SpecResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: SpecResponseV1Kind;
  specId: string;
  version: string;
  spec?: SpecResponseV1Spec;
}

export type StrategyConfigPatchRequestParamsAnyOf = { [key: string]: unknown };

export type StrategyConfigPatchRequestParams = StrategyConfigPatchRequestParamsAnyOf | null;

export type StrategyConfigPatchRequestIndicatorsAnyOf = { [key: string]: unknown };

export type StrategyConfigPatchRequestIndicators = StrategyConfigPatchRequestIndicatorsAnyOf | null;

/**
 * Patch SSOT StrategyConfig (params/indicators).
 */
export interface StrategyConfigPatchRequest {
  params?: StrategyConfigPatchRequestParams;
  indicators?: StrategyConfigPatchRequestIndicators;
}

/**
 * Strategy params (SSOT; includes all trading parameters)
 */
export type StrategyConfigRequestParams = { [key: string]: unknown };

/**
 * Indicator configs used by strategy
 */
export type StrategyConfigRequestIndicators = { [key: string]: unknown };

export type StrategyConfigRequestSymbol = string | null;

export type StrategyConfigRequestInterval = string | null;

/**
 * Каноничный payload стратегии для backtest/runtime.

Wire-format: camelCase через BaseSchema (strategyType, ...)
 */
export interface StrategyConfigRequest {
  /** Resolved strategy type from strategy_spec (default: custom) */
  strategyType?: string;
  /** Strategy params (SSOT; includes all trading parameters) */
  params?: StrategyConfigRequestParams;
  /** Indicator configs used by strategy */
  indicators?: StrategyConfigRequestIndicators;
  symbol?: StrategyConfigRequestSymbol;
  interval?: StrategyConfigRequestInterval;
}

export type StrategyNodeV1Config = { [key: string]: unknown };

export interface StrategyNodeV1 {
  /**
   * @minLength 1
   * @maxLength 128
   */
  nodeId: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  nodeType: string;
  config?: StrategyNodeV1Config;
}

export type StrategyPreflightRequestStrategyType = string | null;

/**
 * Required strategy spec reference: {spec_id, version, digest}.
 */
export type StrategyPreflightRequestStrategySpec = {[key: string]: string};

export type StrategyPreflightRequestParamsAnyOf = { [key: string]: unknown };

export type StrategyPreflightRequestParams = StrategyPreflightRequestParamsAnyOf | null;

export type StrategyPreflightRequestIndicatorsAnyOf = { [key: string]: unknown };

export type StrategyPreflightRequestIndicators = StrategyPreflightRequestIndicatorsAnyOf | null;

/**
 * Read-only preview of effective strategy params before create/start.
 */
export interface StrategyPreflightRequest {
  strategyType?: StrategyPreflightRequestStrategyType;
  /** Required strategy spec reference: {spec_id, version, digest}. */
  strategySpec: StrategyPreflightRequestStrategySpec;
  params?: StrategyPreflightRequestParams;
  indicators?: StrategyPreflightRequestIndicators;
}

export type StrategySpecV1Status = typeof StrategySpecV1Status[keyof typeof StrategySpecV1Status];


 
export const StrategySpecV1Status = {
  DRAFT: 'DRAFT',
  READY: 'READY',
  FAILED: 'FAILED',
  DEPRECATED: 'DEPRECATED',
} as const;

export type StrategySpecV1RuntimeInterface = typeof StrategySpecV1RuntimeInterface[keyof typeof StrategySpecV1RuntimeInterface];


 
export const StrategySpecV1RuntimeInterface = {
  StrategyV1: 'StrategyV1',
  StrategyMultiAssetV2: 'StrategyMultiAssetV2',
} as const;

export type StrategySpecV1StateSchema = { [key: string]: unknown };

export type StrategySpecV1InputContract = { [key: string]: unknown };

export type StrategySpecV1WarmupContract = { [key: string]: unknown };

export type StrategySpecV1TemporalPolicy = { [key: string]: unknown };

export type StrategySpecV1ModeCompatibility = { [key: string]: unknown };

export type StrategySpecV1PortfolioAccess = { [key: string]: unknown };

export type StrategySpecV1InstrumentScope = { [key: string]: unknown };

export type StrategySpecV1DefaultIndicators = { [key: string]: unknown };

export type StrategySpecV1ContextUsageMode = typeof StrategySpecV1ContextUsageMode[keyof typeof StrategySpecV1ContextUsageMode];


 
export const StrategySpecV1ContextUsageMode = {
  signal_only: 'signal_only',
  risk_aware: 'risk_aware',
  portfolio_aware: 'portfolio_aware',
} as const;

export interface StrategySpecV1 {
  schemaVersion?: string;
  kind?: 'strategy';
  /**
   * @minLength 1
   * @maxLength 128
   */
  specId: string;
  /**
   * @minLength 1
   * @maxLength 64
   */
  version: string;
  /** @maxLength 255 */
  name?: string;
  description?: string;
  status?: StrategySpecV1Status;
  /**
   * @minLength 1
   * @maxLength 128
   */
  strategyType?: string;
  runtimeInterface?: StrategySpecV1RuntimeInterface;
  stateSchema?: StrategySpecV1StateSchema;
  /** @minimum 1 */
  stateSchemaVersion?: number;
  inputContract?: StrategySpecV1InputContract;
  warmupContract?: StrategySpecV1WarmupContract;
  temporalPolicy?: StrategySpecV1TemporalPolicy;
  modeCompatibility?: StrategySpecV1ModeCompatibility;
  portfolioAccess?: StrategySpecV1PortfolioAccess;
  instrumentScope?: StrategySpecV1InstrumentScope;
  nodes?: StrategyNodeV1[];
  paramDefinitions?: ParamDefinitionV1[];
  defaultIndicators?: StrategySpecV1DefaultIndicators;
  indicatorRefs?: string[];
  /** Поля runtime-контекста стратегии; префлайт проверяет объявление в коде и готовность источников. */
  requiredContextFields?: string[];
  contextUsageMode?: StrategySpecV1ContextUsageMode;
  /** Зарезервировано; исполнение на стороне runtime пока не связывается с префлайтом агента. */
  riskDependencies?: string[];
  code?: CodeSourceV1;
}

export type SuccessResponseMessage = string | null;

export type SuccessResponseData = unknown | null;

/**
 * Успешный ответ.
 */
export interface SuccessResponse {
  success?: boolean;
  message?: SuccessResponseMessage;
  data?: SuccessResponseData;
}

export interface Summary {
  signalsCount?: number;
  ordersCount?: number;
  fillsCount?: number;
  openPositionsCount?: number;
  closedTradesCount?: number;
  realizedPnl?: number;
  unrealizedPnl?: number;
  winsCount?: number;
  lossesCount?: number;
}

/**
 * Системные ресурсы для UI мониторинга.
 */
export interface SystemResources {
  cpu: Cpu;
  memory: Memory;
  disk: Disk;
  connections: number;
  threads: number;
  timestamp: string;
}

export type TickerInfoBid = number | null;

export type TickerInfoAsk = number | null;

export type TickerInfoLastTradePrice = number | null;

export type TickerInfoVolume = number | null;

export type TickerInfoChange = number | null;

export type TickerInfoChangePercent = number | null;

/**
 * Информация о тикере. Единый канон: last_trade_price (DATA_PLANE_OPS_PLANE).
 */
export interface TickerInfo {
  symbol: string;
  bid?: TickerInfoBid;
  ask?: TickerInfoAsk;
  lastTradePrice?: TickerInfoLastTradePrice;
  volume?: TickerInfoVolume;
  change?: TickerInfoChange;
  changePercent?: TickerInfoChangePercent;
  timestamp: number;
}

export type TradeFillRequestPrice = number | string;

export type TradeFillRequestQty = number | string;

export type TradeFillRequestSide = string | null;

export type TradeFillRequestCommission = number | string | null;

export type TradeFillRequestCommissionAsset = string | null;

export type TradeFillRequestStatus = string | null;

export type TradeFillRequestAvgPriceAnyOf = number | string;

export type TradeFillRequestAvgPrice = TradeFillRequestAvgPriceAnyOf | null;

export type TradeFillRequestFilledQty = number | string | null;

export type TradeFillRequestExecutedQty = number | string | null;

export type TradeFillRequestId = string | null;

/**
 * Запрос на сохранение fill с поддержкой legacy-полей.
 */
export interface TradeFillRequest {
  clientOrderId: string;
  trade_id: string;
  price: TradeFillRequestPrice;
  qty: TradeFillRequestQty;
  executed_at: string;
  side?: TradeFillRequestSide;
  commission?: TradeFillRequestCommission;
  commissionAsset?: TradeFillRequestCommissionAsset;
  status?: TradeFillRequestStatus;
  avgPrice?: TradeFillRequestAvgPrice;
  filledQty?: TradeFillRequestFilledQty;
  executedQty?: TradeFillRequestExecutedQty;
  id?: TradeFillRequestId;
}

export type TradingRuntimeProjectionResponseSymbol = string | null;

export type TradingRuntimeProjectionResponseLifecycleReason = string | null;

export type TradingRuntimeProjectionResponseLastEventAt = string | null;

export type TradingRuntimeProjectionResponseLatestSignal = RuntimeSignalSnapshot | null;

export type TradingRuntimeProjectionResponseLatestOrder = RuntimeOrderSnapshot | null;

export type TradingRuntimeProjectionResponseLatestFill = RuntimeFillSnapshot | null;

export type TradingRuntimeProjectionResponseOpenPosition = RuntimePositionSnapshot | null;

export type TradingRuntimeProjectionResponseLatestTrade = CompletedTradeResponse | null;

/**
 * Единый runtime read-model для signal/execution/fill/position/trade.
 */
export interface TradingRuntimeProjectionResponse {
  agentId: string;
  symbol?: TradingRuntimeProjectionResponseSymbol;
  lifecycleStatus: string;
  lifecycleReason?: TradingRuntimeProjectionResponseLifecycleReason;
  lastEventAt?: TradingRuntimeProjectionResponseLastEventAt;
  summary: Summary;
  latestSignal?: TradingRuntimeProjectionResponseLatestSignal;
  latestOrder?: TradingRuntimeProjectionResponseLatestOrder;
  latestFill?: TradingRuntimeProjectionResponseLatestFill;
  openPosition?: TradingRuntimeProjectionResponseOpenPosition;
  latestTrade?: TradingRuntimeProjectionResponseLatestTrade;
  recentFills?: RuntimeFillSnapshot[];
}

export type UpdateIndicatorParamsRequestParams = { [key: string]: unknown };

export interface UpdateIndicatorParamsRequest {
  params?: UpdateIndicatorParamsRequestParams;
}

export interface ValidateResponseV1 {
  requestId: string;
  schemaVersion?: string;
  valid: boolean;
  errors?: string[];
  warnings?: string[];
  hints?: string[];
}

export type ValidationErrorLocItem = string | number;

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}

export type VersionsResponseV1Kind = typeof VersionsResponseV1Kind[keyof typeof VersionsResponseV1Kind];


 
export const VersionsResponseV1Kind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export interface VersionsResponseV1 {
  requestId: string;
  schemaVersion?: string;
  kind: VersionsResponseV1Kind;
  specId: string;
  versions?: string[];
}

export type ReadinessCheckApiHealthReadyzGetParams = {
strict?: boolean;
};

export type GetStreamHealthApiHealthHealthStreamGet200 = { [key: string]: unknown };

export type GetLakeHealthApiHealthHealthLakeGet200 = { [key: string]: unknown };

export type GetLakeHealthApiHealthLakeGet200 = { [key: string]: unknown };

export type GetLakeRetentionPlanApiHealthHealthLakeRetentionPlanGetParams = {
/**
 * @minimum 1
 * @maximum 3650
 */
retention_days?: number;
max_rows_to_scan?: number | null;
};

export type GetLakeRetentionPlanApiHealthHealthLakeRetentionPlanGet200 = { [key: string]: unknown };

export type GetLakeRetentionPlanApiHealthLakeRetentionPlanGetParams = {
/**
 * @minimum 1
 * @maximum 3650
 */
retention_days?: number;
max_rows_to_scan?: number | null;
};

export type GetLakeRetentionPlanApiHealthLakeRetentionPlanGet200 = { [key: string]: unknown };

export type GetCoverageLedgerApiHealthCoverageLedgerGetParams = {
/**
 * @minLength 1
 */
symbol: string;
/**
 * @minLength 1
 */
interval_id: string;
};

export type GetCoverageLedgerApiHealthCoverageLedgerGet200 = { [key: string]: unknown };

export type GetAgentDefinitionApiAgentsAgentIdDefinitionGet200 = { [key: string]: unknown };

export type PatchAgentDefinitionApiAgentsAgentIdDefinitionPatch200 = { [key: string]: unknown };

export type StrategyPreflightApiAgentsStrategyPreflightPost200 = { [key: string]: unknown };

export type DeleteAgentApiAgentsAgentIdDelete200 = { [key: string]: unknown };

export type GetAgentBackfillStatusApiAgentsAgentIdBackfillStatusGet200 = { [key: string]: unknown };

export type StartAgentApiAgentsAgentIdStartPost200 = { [key: string]: unknown };

export type StopAgentApiAgentsAgentIdStopPost200 = { [key: string]: unknown };

export type ListBacktestsApiBacktestGetParams = {
symbol?: string | null;
status?: string | null;
limit?: number;
offset?: number;
};

export type CancelBacktestApiBacktestBacktestIdDelete200 = {[key: string]: string};

export type GetBacktestProgressApiBacktestBacktestIdProgressGet200 = { [key: string]: unknown };

export type GetBacktestTradesApiBacktestBacktestIdTradesGet200Item = { [key: string]: unknown };

export type GetBacktestMetricsApiBacktestBacktestIdMetricsGet200AnyOf = { [key: string]: unknown };

export type GetBacktestMetricsApiBacktestBacktestIdMetricsGet200 = GetBacktestMetricsApiBacktestBacktestIdMetricsGet200AnyOf | null;

export type OptimizeBacktestApiBacktestOptimizePost200 = {[key: string]: string};

export type ListOptimizationsApiBacktestOptimizeGetParams = {
symbol?: string | null;
strategy_type?: string | null;
status?: string | null;
limit?: number;
offset?: number;
};

export type OptimizationLeaderboardApiBacktestOptimizeLeaderboardGetParams = {
symbol?: string | null;
strategy_type?: string | null;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
/**
 * Если true, включать только записи с непустым resolved_digest.
 */
require_resolved_digest?: boolean;
};

export type GetTradesApiTradesGetParams = {
/**
 * Filter by agent ID
 */
agent_id?: string | null;
/**
 * Filter by symbol (e.g. BTCUSDT)
 */
symbol?: string | null;
/**
 * ISO datetime (entry_time >= start_time)
 */
start_time?: string | null;
/**
 * ISO datetime (exit_time <= end_time)
 */
end_time?: string | null;
/**
 * Maximum number of trades to return
 * @minimum 1
 * @maximum 10000
 */
limit?: number;
/**
 * Offset for pagination
 * @minimum 0
 * @maximum 1000000
 */
offset?: number;
};

export type GetRuntimeProjectionApiTradesRuntimeGetParams = {
/**
 * Agent ID
 */
agent_id: string;
/**
 * Filter by symbol (e.g. BTCUSDT)
 */
symbol?: string | null;
};

export type GetSignalsApiSignalsGetParams = {
/**
 * Filter by agent ID
 */
agent_id?: string | null;
/**
 * Filter by symbol (e.g. BTCUSDT)
 */
symbol?: string | null;
/**
 * Filter by status (ACTIVE, EXECUTED, CANCELLED)
 */
status?: string | null;
/**
 * ISO datetime (timestamp >= start_time)
 */
start_time?: string | null;
/**
 * ISO datetime (timestamp <= end_time)
 */
end_time?: string | null;
/**
 * Minimum confidence level
 */
min_confidence?: number | null;
/**
 * Maximum number of signals to return
 * @minimum 1
 * @maximum 10000
 */
limit?: number;
/**
 * Offset for pagination
 * @minimum 0
 * @maximum 1000000
 */
offset?: number;
};

export type GetActiveSignalsApiSignalsAgentIdActiveGetParams = {
/**
 * Filter by symbol
 */
symbol?: string | null;
};

export type ListBrokersApiBrokersListGet200 = {[key: string]: BrokerInstance};

export type GetOrdersApiBrokersAgentIdOrdersGetParams = {
symbol?: string | null;
status?: string | null;
/**
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
};

export type GetPositionsApiBrokersAgentIdPositionsGetParams = {
symbol?: string | null;
};

export type GetMarketDataApiMarketDataSymbolGetParams = {
interval?: string;
/**
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
start_time?: string | null;
end_time?: string | null;
};

export type IngestMarketCalendarEventApiMarketCalendarEventsIngestPost200 = { [key: string]: unknown };

export type ListMarketCalendarEventsApiMarketCalendarEventsGetParams = {
/**
 * Символ (или * для market-wide через symbol_scope)
 */
symbol: string;
/**
 * @minimum 0
 */
start_ts_ms: number;
/**
 * @minimum 0
 */
end_ts_ms: number;
};

export type ListMarketCalendarEventsApiMarketCalendarEventsGet200 = { [key: string]: unknown };

export type IngestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPost200 = { [key: string]: unknown };

export type ListDerivativesSnapshotsApiMarketDerivativesSnapshotsGetParams = {
symbol: string;
/**
 * @minimum 0
 */
start_ts_ms: number;
/**
 * @minimum 0
 */
end_ts_ms: number;
};

export type ListDerivativesSnapshotsApiMarketDerivativesSnapshotsGet200 = { [key: string]: unknown };

export type GetHistoricalBarsApiMarketHistorySymbolIntervalGetParams = {
/**
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
/**
 * JSON array of chart indicator projections: [{name, params}]
 */
indicators_json?: string | null;
};

export type GetMarketLimitsApiMarketLimitsGet200 = {[key: string]: number};

export type GetHistoricalBarsQueryApiMarketHistoryGetParams = {
/**
 * Торговый символ (обязателен без agent_id)
 */
symbol?: string | null;
/**
 * Канонический interval_id: T:5m / X:500t
 */
interval?: string | null;
/**
 * @minimum 1
 */
limit?: number;
/**
 * Начало диапазона (ms UTC)
 */
from?: number | null;
/**
 * Конец диапазона (ms UTC)
 */
to?: number | null;
/**
 * ID агента: symbol/interval/окно берутся из definition (history_lookback_hours)
 */
agent_id?: string | null;
/**
 * JSON array of chart indicator projections: [{name, params}]
 */
indicators_json?: string | null;
};

export type GetBarsPageApiMarketBarsSymbolIntervalGetParams = {
/**
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
/**
 * Вернуть бары строго до (<=) указанного open time в ms UTC
 */
before_ts_ms?: number | null;
/**
 * JSON array of chart indicator projections: [{name, params}]
 */
indicators_json?: string | null;
};

export type RegisterIntervalApiIntervalsSymbolPostParams = {
interval_id: string;
kind?: string | null;
enabled?: boolean;
priority?: number;
};

export type RegisterIntervalApiIntervalsSymbolPost200 = { [key: string]: unknown };

export type UnregisterIntervalApiIntervalsSymbolIntervalIdDelete200 = { [key: string]: unknown };

export type GetAllIntervalsApiIntervalsGet200 = { [key: string]: unknown };

export type GetCircuitBreakersApiMetricsCircuitBreakersGet200 = { [key: string]: unknown };

export type ResetCircuitBreakerApiMetricsCircuitBreakersNameResetPost200 = {[key: string]: string};

export type GetBinanceMetricsApiMetricsBinanceGet200 = { [key: string]: unknown };

export type GetSchemaApiIndicatorsNameSchemaGet200 = { [key: string]: unknown };

export type UpdateParamsApiIndicatorsNameParamsPut200 = { [key: string]: unknown };

export type GetAuditEventsApiTradingSpecsKindSpecIdVersionAuditEventsGetParams = {
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
};

export type CatalogIndicatorsApiTradingSpecsCatalogIndicatorsGetParams = {
status?: string;
};

export type CatalogStrategiesApiTradingSpecsCatalogStrategiesGetParams = {
status?: string;
};

export type ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetParams = {
mode?: ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetMode;
};

export type ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetMode = typeof ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetMode[keyof typeof ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetMode];


 
export const ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetMode = {
  agent: 'agent',
  backtest: 'backtest',
  opt: 'opt',
} as const;

export type TradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGet200 = { [key: string]: unknown };

export type GetAiContractsApiTradingSpecsAiContractsGetParams = {
kind: GetAiContractsApiTradingSpecsAiContractsGetKind;
};

export type GetAiContractsApiTradingSpecsAiContractsGetKind = typeof GetAiContractsApiTradingSpecsAiContractsGetKind[keyof typeof GetAiContractsApiTradingSpecsAiContractsGetKind];


 
export const GetAiContractsApiTradingSpecsAiContractsGetKind = {
  indicator: 'indicator',
  strategy: 'strategy',
} as const;

export type GetStatisticsSummaryApiStatsSummaryGetParams = {
/**
 * Agent ID
 */
agent_id: string;
/**
 * Timeframe: day, week, month, all
 */
timeframe?: string;
/**
 * Filter by trade side: BUY, SELL, or None for all
 */
side?: string | null;
};

export type ExportTradesApiStatsExportGetParams = {
/**
 * Agent ID
 */
agent_id: string;
/**
 * Export format: csv or json
 */
format?: string;
/**
 * Start date (ISO format)
 */
start_date?: string | null;
/**
 * End date (ISO format)
 */
end_date?: string | null;
};

export type GetPerformanceDataApiStatsPerformanceGetParams = {
/**
 * Agent ID
 */
agent_id: string;
/**
 * Period: hour, day, week, month
 */
period?: string;
/**
 * Number of data points
 */
limit?: number;
};

export type GetMetricsOverviewApiWsMetricsOverviewGet200 = { [key: string]: unknown };

export type GetChannelMetricsApiWsMetricsChannelsChannelGet200 = { [key: string]: unknown };

export type GetConnectionMetricsApiWsMetricsConnectionsWsIdGet200 = { [key: string]: unknown };

export type ListChannelsApiWsMetricsChannelsGetParams = {
/**
 * Показывать только активные каналы
 */
active_only?: boolean;
/**
 * Сортировка: throughput, subscribers, latency
 */
sort_by?: string;
};

export type ListChannelsApiWsMetricsChannelsGet200 = { [key: string]: unknown };

export type ListConnectionsApiWsMetricsConnectionsGetParams = {
/**
 * Максимальное количество соединений
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
};

export type ListConnectionsApiWsMetricsConnectionsGet200 = { [key: string]: unknown };

export type GetAlertsApiWsMetricsAlertsGetParams = {
/**
 * Максимальное количество алертов
 * @minimum 1
 * @maximum 100
 */
limit?: number;
};

export type GetAlertsApiWsMetricsAlertsGet200 = { [key: string]: unknown };

export type ClearAlertsApiWsMetricsAlertsClearPost200 = { [key: string]: unknown };

export type GetStatsApiWsMetricsStatsGet200 = { [key: string]: unknown };

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAlgoSysAPI = () => {
/**
 * Базовая проверка здоровья приложения.
Возвращает 200 если сервис работает.

Этот endpoint должен быть максимально быстрым и не зависеть от внешних сервисов.
Используется для liveness probe в Kubernetes/Docker.
 * @summary Health Check
 */
const healthCheckApiHealthHealthzGet = (
    
 options?: SecondParameter<typeof customInstance<HealthCheck>>,) => {
      return customInstance<HealthCheck>(
      {url: `/api/health/healthz`, method: 'GET'
    },
      options);
    }
  
/**
 * Проверка готовности всех компонентов системы.

`strict=false` подходит для UI/диагностики и всегда возвращает JSON c деталями.
`strict=true` возвращает HTTP 503 при `not_ready` и подходит для оркестратора.
 * @summary Readiness Check
 */
const readinessCheckApiHealthReadyzGet = (
    params?: ReadinessCheckApiHealthReadyzGetParams,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/health/readyz`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить информацию об использовании системных ресурсов.

Возвращает детальную информацию о CPU, памяти, диске,
соединениях и потоках для мониторинга производительности.
При отсутствии psutil возвращает минимальные нулевые значения (200), чтобы UI не показывал Unknown.
 * @summary Get System Resources
 */
const getSystemResourcesApiHealthSystemResourcesGet = (
    
 options?: SecondParameter<typeof customInstance<SystemResources>>,) => {
      return customInstance<SystemResources>(
      {url: `/api/health/system/resources`, method: 'GET'
    },
      options);
    }
  
/**
 * Проверка здоровья потока данных (Binance → Bus → Handler → WS).
Возвращает агрегированные метрики ключевых компонентов.
 * @summary Get Stream Health
 */
const getStreamHealthApiHealthHealthStreamGet = (
    
 options?: SecondParameter<typeof customInstance<GetStreamHealthApiHealthHealthStreamGet200>>,) => {
      return customInstance<GetStreamHealthApiHealthHealthStreamGet200>(
      {url: `/api/health/health/stream`, method: 'GET'
    },
      options);
    }
  
/**
 * Проверка потока в Lake: включён ли Lake, доступен ли бэкенд (MinIO/Iceberg),
запущен ли tick persistence worker (Kafka → Lake).
Используется для верификации: поступление и хранение тиков в Lake.
 * @summary Get Lake Health
 */
const getLakeHealthApiHealthHealthLakeGet = (
    
 options?: SecondParameter<typeof customInstance<GetLakeHealthApiHealthHealthLakeGet200>>,) => {
      return customInstance<GetLakeHealthApiHealthHealthLakeGet200>(
      {url: `/api/health/health/lake`, method: 'GET'
    },
      options);
    }
  
/**
 * Проверка потока в Lake: включён ли Lake, доступен ли бэкенд (MinIO/Iceberg),
запущен ли tick persistence worker (Kafka → Lake).
Используется для верификации: поступление и хранение тиков в Lake.
 * @summary Get Lake Health
 */
const getLakeHealthApiHealthLakeGet = (
    
 options?: SecondParameter<typeof customInstance<GetLakeHealthApiHealthLakeGet200>>,) => {
      return customInstance<GetLakeHealthApiHealthLakeGet200>(
      {url: `/api/health/lake`, method: 'GET'
    },
      options);
    }
  
/**
 * Dry-run план retention по ticks Lake без удаления данных.
При max_rows_to_scan — приближённые счётчики (без полного скана).
 * @summary Get Lake Retention Plan
 */
const getLakeRetentionPlanApiHealthHealthLakeRetentionPlanGet = (
    params?: GetLakeRetentionPlanApiHealthHealthLakeRetentionPlanGetParams,
 options?: SecondParameter<typeof customInstance<GetLakeRetentionPlanApiHealthHealthLakeRetentionPlanGet200>>,) => {
      return customInstance<GetLakeRetentionPlanApiHealthHealthLakeRetentionPlanGet200>(
      {url: `/api/health/health/lake/retention-plan`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Dry-run план retention по ticks Lake без удаления данных.
При max_rows_to_scan — приближённые счётчики (без полного скана).
 * @summary Get Lake Retention Plan
 */
const getLakeRetentionPlanApiHealthLakeRetentionPlanGet = (
    params?: GetLakeRetentionPlanApiHealthLakeRetentionPlanGetParams,
 options?: SecondParameter<typeof customInstance<GetLakeRetentionPlanApiHealthLakeRetentionPlanGet200>>,) => {
      return customInstance<GetLakeRetentionPlanApiHealthLakeRetentionPlanGet200>(
      {url: `/api/health/lake/retention-plan`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Статус Session START ledger для пары (symbol, interval_id):
queued/running/failed/complete + last_error и расчётные границы.
 * @summary Get Coverage Ledger
 */
const getCoverageLedgerApiHealthCoverageLedgerGet = (
    params: GetCoverageLedgerApiHealthCoverageLedgerGetParams,
 options?: SecondParameter<typeof customInstance<GetCoverageLedgerApiHealthCoverageLedgerGet200>>,) => {
      return customInstance<GetCoverageLedgerApiHealthCoverageLedgerGet200>(
      {url: `/api/health/coverage/ledger`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Каноничное SSOT описание агента (definition), хранимое в Redis.
Если агент не в registry (не запущен), возвращаем данные из Redis или минимальный стаб — UI не получает 404.
 * @summary Get Agent Definition
 */
const getAgentDefinitionApiAgentsAgentIdDefinitionGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<GetAgentDefinitionApiAgentsAgentIdDefinitionGet200>>,) => {
      return customInstance<GetAgentDefinitionApiAgentsAgentIdDefinitionGet200>(
      {url: `/api/agents/${agentId}/definition`, method: 'GET'
    },
      options);
    }
  
/**
 * Patch SSOT agent definition (name/autostart).
 * @summary Patch Agent Definition
 */
const patchAgentDefinitionApiAgentsAgentIdDefinitionPatch = (
    agentId: string,
    agentDefinitionPatchRequest: AgentDefinitionPatchRequest,
 options?: SecondParameter<typeof customInstance<PatchAgentDefinitionApiAgentsAgentIdDefinitionPatch200>>,) => {
      return customInstance<PatchAgentDefinitionApiAgentsAgentIdDefinitionPatch200>(
      {url: `/api/agents/${agentId}/definition`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: agentDefinitionPatchRequest
    },
      options);
    }
  
/**
 * Preview merge result for strategy config without side effects.
Used by UI before Create/Start to show effective values and sources.
 * @summary Strategy Preflight
 */
const strategyPreflightApiAgentsStrategyPreflightPost = (
    strategyPreflightRequest: StrategyPreflightRequest,
 options?: SecondParameter<typeof customInstance<StrategyPreflightApiAgentsStrategyPreflightPost200>>,) => {
      return customInstance<StrategyPreflightApiAgentsStrategyPreflightPost200>(
      {url: `/api/agents/strategy-preflight`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: strategyPreflightRequest
    },
      options);
    }
  
/**
 * Получить список всех агентов.
 * @summary List Agents
 */
const listAgentsApiAgentsGet = (
    
 options?: SecondParameter<typeof customInstance<AgentResponse[]>>,) => {
      return customInstance<AgentResponse[]>(
      {url: `/api/agents/`, method: 'GET'
    },
      options);
    }
  
/**
 * Создать нового агента.
 * @summary Create Agent
 */
const createAgentApiAgentsPost = (
    simpleAgentCreateRequest: SimpleAgentCreateRequest,
 options?: SecondParameter<typeof customInstance<AgentResponse>>,) => {
      return customInstance<AgentResponse>(
      {url: `/api/agents/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simpleAgentCreateRequest
    },
      options);
    }
  
/**
 * Получить агента по ID.
 * @summary Get Agent
 */
const getAgentApiAgentsAgentIdGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<AgentResponse>>,) => {
      return customInstance<AgentResponse>(
      {url: `/api/agents/${agentId}`, method: 'GET'
    },
      options);
    }
  
/**
 * Удалить агента.
 * @summary Delete Agent
 */
const deleteAgentApiAgentsAgentIdDelete = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<DeleteAgentApiAgentsAgentIdDelete200>>,) => {
      return customInstance<DeleteAgentApiAgentsAgentIdDelete200>(
      {url: `/api/agents/${agentId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * Получить SSOT StrategyConfig агента (params + indicators).

Канон: все торговые параметры находятся в strategy params.
 * @summary Get Agent Strategy Config
 */
const getAgentStrategyConfigApiAgentsAgentIdStrategyConfigGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<StrategyConfigRequest>>,) => {
      return customInstance<StrategyConfigRequest>(
      {url: `/api/agents/${agentId}/strategy-config`, method: 'GET'
    },
      options);
    }
  
/**
 * Обновить SSOT StrategyConfig агента (runtime).

Канон:
- отдельного блока параметров не существует, изменения идут только в params/indicators
- индикаторные параметры храним под ключами индикаторов (нормализуем в lower)
 * @summary Patch Agent Strategy Config
 */
const patchAgentStrategyConfigApiAgentsAgentIdStrategyConfigPatch = (
    agentId: string,
    strategyConfigPatchRequest: StrategyConfigPatchRequest,
 options?: SecondParameter<typeof customInstance<StrategyConfigRequest>>,) => {
      return customInstance<StrategyConfigRequest>(
      {url: `/api/agents/${agentId}/strategy-config`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: strategyConfigPatchRequest
    },
      options);
    }
  
/**
 * @summary Get Agent Runtime State
 */
const getAgentRuntimeStateApiAgentsAgentIdRuntimeStateGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<AgentRuntimeStateResponse>>,) => {
      return customInstance<AgentRuntimeStateResponse>(
      {url: `/api/agents/${agentId}/runtime-state`, method: 'GET'
    },
      options);
    }
  
/**
 * Статус Session START backfill для агента (опрос UI после create/start).
 * @summary Get Agent Backfill Status
 */
const getAgentBackfillStatusApiAgentsAgentIdBackfillStatusGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<GetAgentBackfillStatusApiAgentsAgentIdBackfillStatusGet200>>,) => {
      return customInstance<GetAgentBackfillStatusApiAgentsAgentIdBackfillStatusGet200>(
      {url: `/api/agents/${agentId}/backfill-status`, method: 'GET'
    },
      options);
    }
  
/**
 * Запустить агента.
 * @summary Start Agent
 */
const startAgentApiAgentsAgentIdStartPost = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<StartAgentApiAgentsAgentIdStartPost200>>,) => {
      return customInstance<StartAgentApiAgentsAgentIdStartPost200>(
      {url: `/api/agents/${agentId}/start`, method: 'POST'
    },
      options);
    }
  
/**
 * Остановить агента.
 * @summary Stop Agent
 */
const stopAgentApiAgentsAgentIdStopPost = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<StopAgentApiAgentsAgentIdStopPost200>>,) => {
      return customInstance<StopAgentApiAgentsAgentIdStopPost200>(
      {url: `/api/agents/${agentId}/stop`, method: 'POST'
    },
      options);
    }
  
/**
 * Запустить бэктест с заданными параметрами.
 * @summary Run backtest
 */
const runBacktestApiBacktestPost = (
    backtestRequest: BacktestRequest,
 options?: SecondParameter<typeof customInstance<BacktestResponse>>,) => {
      return customInstance<BacktestResponse>(
      {url: `/api/backtest/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: backtestRequest
    },
      options);
    }
  
/**
 * Получить список бэктестов с фильтрами.
 * @summary List backtests
 */
const listBacktestsApiBacktestGet = (
    params?: ListBacktestsApiBacktestGetParams,
 options?: SecondParameter<typeof customInstance<PaginatedResponseBacktestListResponse>>,) => {
      return customInstance<PaginatedResponseBacktestListResponse>(
      {url: `/api/backtest/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить результаты бэктеста по ID.
 * @summary Get backtest result
 */
const getBacktestResultApiBacktestBacktestIdGet = (
    backtestId: string,
 options?: SecondParameter<typeof customInstance<BacktestResultResponse>>,) => {
      return customInstance<BacktestResultResponse>(
      {url: `/api/backtest/${backtestId}`, method: 'GET'
    },
      options);
    }
  
/**
 * Отменить выполняющийся бэктест.
 * @summary Cancel backtest
 */
const cancelBacktestApiBacktestBacktestIdDelete = (
    backtestId: string,
 options?: SecondParameter<typeof customInstance<CancelBacktestApiBacktestBacktestIdDelete200>>,) => {
      return customInstance<CancelBacktestApiBacktestBacktestIdDelete200>(
      {url: `/api/backtest/${backtestId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * Получить прогресс выполнения бэктеста.
 * @summary Get backtest progress
 */
const getBacktestProgressApiBacktestBacktestIdProgressGet = (
    backtestId: string,
 options?: SecondParameter<typeof customInstance<GetBacktestProgressApiBacktestBacktestIdProgressGet200>>,) => {
      return customInstance<GetBacktestProgressApiBacktestBacktestIdProgressGet200>(
      {url: `/api/backtest/${backtestId}/progress`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить список сделок бэктеста.
 * @summary Get backtest trades
 */
const getBacktestTradesApiBacktestBacktestIdTradesGet = (
    backtestId: string,
 options?: SecondParameter<typeof customInstance<GetBacktestTradesApiBacktestBacktestIdTradesGet200Item[]>>,) => {
      return customInstance<GetBacktestTradesApiBacktestBacktestIdTradesGet200Item[]>(
      {url: `/api/backtest/${backtestId}/trades`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить метрики производительности бэктеста.
 * @summary Get backtest metrics
 */
const getBacktestMetricsApiBacktestBacktestIdMetricsGet = (
    backtestId: string,
 options?: SecondParameter<typeof customInstance<GetBacktestMetricsApiBacktestBacktestIdMetricsGet200>>,) => {
      return customInstance<GetBacktestMetricsApiBacktestBacktestIdMetricsGet200>(
      {url: `/api/backtest/${backtestId}/metrics`, method: 'GET'
    },
      options);
    }
  
/**
 * Запустить оптимизацию параметров бэктеста.
 * @summary Run parameter optimization
 */
const optimizeBacktestApiBacktestOptimizePost = (
    backtestOptimizeRequest: BacktestOptimizeRequest,
 options?: SecondParameter<typeof customInstance<OptimizeBacktestApiBacktestOptimizePost200>>,) => {
      return customInstance<OptimizeBacktestApiBacktestOptimizePost200>(
      {url: `/api/backtest/optimize`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: backtestOptimizeRequest
    },
      options);
    }
  
/**
 * Получить список оптимизаций.
 * @summary List optimizations
 */
const listOptimizationsApiBacktestOptimizeGet = (
    params?: ListOptimizationsApiBacktestOptimizeGetParams,
 options?: SecondParameter<typeof customInstance<PaginatedResponseOptimizationListResponse>>,) => {
      return customInstance<PaginatedResponseOptimizationListResponse>(
      {url: `/api/backtest/optimize`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить прогресс оптимизации параметров.
 * @summary Get optimization progress
 */
const getOptimizationProgressApiBacktestOptimizeOptimizationIdProgressGet = (
    optimizationId: string,
 options?: SecondParameter<typeof customInstance<OptimizationProgressResponse>>,) => {
      return customInstance<OptimizationProgressResponse>(
      {url: `/api/backtest/optimize/${optimizationId}/progress`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить детальную информацию об оптимизации.
 * @summary Get optimization details
 */
const getOptimizationApiBacktestOptimizeOptimizationIdGet = (
    optimizationId: string,
 options?: SecondParameter<typeof customInstance<OptimizationDetailResponse>>,) => {
      return customInstance<OptimizationDetailResponse>(
      {url: `/api/backtest/optimize/${optimizationId}`, method: 'GET'
    },
      options);
    }
  
/**
 * Сравнить optimization runs только в пределах одной compatibility group.
 * @summary Compare optimization runs
 */
const compareOptimizationsApiBacktestOptimizeComparePost = (
    compareOptimizationsRequest: CompareOptimizationsRequest,
 options?: SecondParameter<typeof customInstance<CompareOptimizationsResponse>>,) => {
      return customInstance<CompareOptimizationsResponse>(
      {url: `/api/backtest/optimize/compare`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: compareOptimizationsRequest
    },
      options);
    }
  
/**
 * Получить leaderboard оптимизаций с ссылкой на resolved_digest.
 * @summary Optimization leaderboard
 */
const optimizationLeaderboardApiBacktestOptimizeLeaderboardGet = (
    params?: OptimizationLeaderboardApiBacktestOptimizeLeaderboardGetParams,
 options?: SecondParameter<typeof customInstance<OptimizationLeaderboardResponse>>,) => {
      return customInstance<OptimizationLeaderboardResponse>(
      {url: `/api/backtest/optimize/leaderboard`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить список сделок с метаданными сигналов (обогащение в use case, без утечки моделей БД).
 * @summary Get Trades
 */
const getTradesApiTradesGet = (
    params?: GetTradesApiTradesGetParams,
 options?: SecondParameter<typeof customInstance<CompletedTradeResponse[]>>,) => {
      return customInstance<CompletedTradeResponse[]>(
      {url: `/api/trades/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Единый runtime read-model для случая, когда сигналы есть, а trade/stats/chart ещё пусты.
 * @summary Get Runtime Projection
 */
const getRuntimeProjectionApiTradesRuntimeGet = (
    params: GetRuntimeProjectionApiTradesRuntimeGetParams,
 options?: SecondParameter<typeof customInstance<TradingRuntimeProjectionResponse>>,) => {
      return customInstance<TradingRuntimeProjectionResponse>(
      {url: `/api/trades/runtime`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Сохранить исполнение ордера (fill). Обновляет позицию и дневной PnL в Redis для guard max_daily_loss.
Тело: client_order_id, trade_id, price, qty, executed_at (и опционально side, commission и т.д.).
 * @summary Persist Fill
 */
const persistFillApiTradesFillPost = (
    tradeFillRequest: TradeFillRequest,
 options?: SecondParameter<typeof customInstance<SuccessResponse>>,) => {
      return customInstance<SuccessResponse>(
      {url: `/api/trades/fill`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradeFillRequest
    },
      options);
    }
  
/**
 * Получить список торговых сигналов.

Args:
    agent_id: Фильтр по ID агента (опционально)
    symbol: Фильтр по символу (опционально)
    status: Фильтр по статусу (опционально)
    start_time: Начало периода (опционально)
    end_time: Конец периода (опционально)
    min_confidence: Минимальная уверенность (опционально)
    limit: Максимальное количество сигналов
    offset: Смещение
    signal_repo: Репозиторий сигналов (порт)

Returns:
    Список сигналов
 * @summary Get Signals
 */
const getSignalsApiSignalsGet = (
    params?: GetSignalsApiSignalsGetParams,
 options?: SecondParameter<typeof customInstance<SignalResponse[]>>,) => {
      return customInstance<SignalResponse[]>(
      {url: `/api/signals/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить активные сигналы для конкретного агента.

Args:
    agent_id: ID агента
    symbol: Фильтр по символу (опционально)
    signal_repo: Репозиторий сигналов (порт)

Returns:
    Список активных сигналов
 * @summary Get Active Signals
 */
const getActiveSignalsApiSignalsAgentIdActiveGet = (
    agentId: string,
    params?: GetActiveSignalsApiSignalsAgentIdActiveGetParams,
 options?: SecondParameter<typeof customInstance<SignalResponse[]>>,) => {
      return customInstance<SignalResponse[]>(
      {url: `/api/signals/${agentId}/active`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить список доступных типов брокеров.

Returns:
    Список типов брокеров
 * @summary Get Broker Types
 */
const getBrokerTypesApiBrokersTypesGet = (
    
 options?: SecondParameter<typeof customInstance<string[]>>,) => {
      return customInstance<string[]>(
      {url: `/api/brokers/types`, method: 'GET'
    },
      options);
    }
  
/**
 * Создать нового брокера.

Args:
    request: Запрос на создание брокера

Returns:
    Информация о созданном брокере
 * @summary Create Broker
 */
const createBrokerApiBrokersCreatePost = (
    brokerCreateRequest: BrokerCreateRequest,
 options?: SecondParameter<typeof customInstance<BrokerInstance>>,) => {
      return customInstance<BrokerInstance>(
      {url: `/api/brokers/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: brokerCreateRequest
    },
      options);
    }
  
/**
 * Получить список всех созданных брокеров.

Returns:
    Словарь брокеров (broker_id -> BrokerInstance)
 * @summary List Brokers
 */
const listBrokersApiBrokersListGet = (
    
 options?: SecondParameter<typeof customInstance<ListBrokersApiBrokersListGet200>>,) => {
      return customInstance<ListBrokersApiBrokersListGet200>(
      {url: `/api/brokers/list`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить информацию о брокере.

Args:
    broker_id: ID брокера

Returns:
    Информация о брокере
 * @summary Get Broker
 */
const getBrokerApiBrokersBrokerIdGet = (
    brokerId: string,
 options?: SecondParameter<typeof customInstance<BrokerInstance>>,) => {
      return customInstance<BrokerInstance>(
      {url: `/api/brokers/${brokerId}`, method: 'GET'
    },
      options);
    }
  
/**
 * Разместить ордер через брокера агента.
Enterprise: после успешной отправки ордер сохраняется в БД; при исполнении — fill и обновление daily PnL.
 * @summary Place Order
 */
const placeOrderApiBrokersAgentIdOrderPost = (
    agentId: string,
    orderRequest: OrderRequest,
 options?: SecondParameter<typeof customInstance<OrderResponse>>,) => {
      return customInstance<OrderResponse>(
      {url: `/api/brokers/${agentId}/order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orderRequest
    },
      options);
    }
  
/**
 * Отменить ордер.

Args:
    agent_id: ID агента
    request: Запрос на отмену ордера
    registry: Реестр агентов
    user: Текущий пользователь

Returns:
    Результат отмены
 * @summary Cancel Order
 */
const cancelOrderApiBrokersAgentIdOrderDelete = (
    agentId: string,
    cancelOrderRequest: CancelOrderRequest,
 options?: SecondParameter<typeof customInstance<SuccessResponse>>,) => {
      return customInstance<SuccessResponse>(
      {url: `/api/brokers/${agentId}/order`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cancelOrderRequest
    },
      options);
    }
  
/**
 * Получить список ордеров агента.

Args:
    agent_id: ID агента
    symbol: Фильтр по символу
    status: Фильтр по статусу
    limit: Максимальное количество
    registry: Реестр агентов
    user: Текущий пользователь

Returns:
    Список ордеров
 * @summary Get Orders
 */
const getOrdersApiBrokersAgentIdOrdersGet = (
    agentId: string,
    params?: GetOrdersApiBrokersAgentIdOrdersGetParams,
 options?: SecondParameter<typeof customInstance<OrderInfo[]>>,) => {
      return customInstance<OrderInfo[]>(
      {url: `/api/brokers/${agentId}/orders`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить позиции агента.

Args:
    agent_id: ID агента
    symbol: Фильтр по символу
    registry: Реестр агентов
    user: Текущий пользователь

Returns:
    Список позиций
 * @summary Get Positions
 */
const getPositionsApiBrokersAgentIdPositionsGet = (
    agentId: string,
    params?: GetPositionsApiBrokersAgentIdPositionsGetParams,
 options?: SecondParameter<typeof customInstance<Position[]>>,) => {
      return customInstance<Position[]>(
      {url: `/api/brokers/${agentId}/positions`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить информацию об аккаунте.

Args:
    agent_id: ID агента
    registry: Реестр агентов
    user: Текущий пользователь

Returns:
    Информация об аккаунте
 * @summary Get Account Info
 */
const getAccountInfoApiBrokersAgentIdAccountGet = (
    agentId: string,
 options?: SecondParameter<typeof customInstance<AccountInfo>>,) => {
      return customInstance<AccountInfo>(
      {url: `/api/brokers/${agentId}/account`, method: 'GET'
    },
      options);
    }
  
/**
 * Установить плечо для символа (только для Futures).

Args:
    agent_id: ID агента
    request: Запрос на изменение плеча
    registry: Реестр агентов
    user: Текущий пользователь

Returns:
    Результат операции
 * @summary Set Leverage
 */
const setLeverageApiBrokersAgentIdLeveragePost = (
    agentId: string,
    leverageRequest: LeverageRequest,
 options?: SecondParameter<typeof customInstance<SuccessResponse>>,) => {
      return customInstance<SuccessResponse>(
      {url: `/api/brokers/${agentId}/leverage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: leverageRequest
    },
      options);
    }
  
/**
 * Установить тип маржи для символа (только для Futures).

Args:
    agent_id: ID агента
    request: Запрос на изменение типа маржи
    registry: Реестр агентов
    user: Текущий пользователь

Returns:
    Результат операции
 * @summary Set Margin Type
 */
const setMarginTypeApiBrokersAgentIdMarginTypePost = (
    agentId: string,
    marginTypeRequest: MarginTypeRequest,
 options?: SecondParameter<typeof customInstance<SuccessResponse>>,) => {
      return customInstance<SuccessResponse>(
      {url: `/api/brokers/${agentId}/margin-type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: marginTypeRequest
    },
      options);
    }
  
/**
 * Получить исторические данные рынка (бары).
 * @summary Get market data
 */
const getMarketDataApiMarketDataSymbolGet = (
    symbol: string,
    params?: GetMarketDataApiMarketDataSymbolGetParams,
 options?: SecondParameter<typeof customInstance<MarketDataResponse>>,) => {
      return customInstance<MarketDataResponse>(
      {url: `/api/market/data/${symbol}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Канонический backend projection: UI отдаёт текущие bars, backend возвращает готовые indicator series.
Контракт: payload.bars — список MarketBarResponse (без symbol); symbol/interval задаются в payload.
 * @summary Построить backend chart projection
 */
const buildChartProjectionApiMarketChartProjectionPost = (
    marketProjectionRequest: MarketProjectionRequest,
 options?: SecondParameter<typeof customInstance<MarketProjectionResponse>>,) => {
      return customInstance<MarketProjectionResponse>(
      {url: `/api/market/chart-projection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: marketProjectionRequest
    },
      options);
    }
  
/**
 * Агрегирует backend facts для chart UI поверх того же окна баров.
 * @summary Построить backend chart fact model
 */
const buildChartFactsApiMarketChartFactsPost = (
    marketProjectionRequest: MarketProjectionRequest,
 options?: SecondParameter<typeof customInstance<MarketChartFactsResponse>>,) => {
      return customInstance<MarketChartFactsResponse>(
      {url: `/api/market/chart-facts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: marketProjectionRequest
    },
      options);
    }
  
/**
 * @summary Загрузить событие календаря (MVP in-memory)
 */
const ingestMarketCalendarEventApiMarketCalendarEventsIngestPost = (
    marketCalendarEventIngestRequest: MarketCalendarEventIngestRequest,
 options?: SecondParameter<typeof customInstance<IngestMarketCalendarEventApiMarketCalendarEventsIngestPost200>>,) => {
      return customInstance<IngestMarketCalendarEventApiMarketCalendarEventsIngestPost200>(
      {url: `/api/market/calendar-events/ingest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: marketCalendarEventIngestRequest
    },
      options);
    }
  
/**
 * @summary Список событий календаря в окне времени
 */
const listMarketCalendarEventsApiMarketCalendarEventsGet = (
    params: ListMarketCalendarEventsApiMarketCalendarEventsGetParams,
 options?: SecondParameter<typeof customInstance<ListMarketCalendarEventsApiMarketCalendarEventsGet200>>,) => {
      return customInstance<ListMarketCalendarEventsApiMarketCalendarEventsGet200>(
      {url: `/api/market/calendar-events`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Загрузить снимок деривативов (MVP in-memory)
 */
const ingestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPost = (
    derivativesSnapshotIngestRequest: DerivativesSnapshotIngestRequest,
 options?: SecondParameter<typeof customInstance<IngestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPost200>>,) => {
      return customInstance<IngestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPost200>(
      {url: `/api/market/derivatives-snapshots/ingest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: derivativesSnapshotIngestRequest
    },
      options);
    }
  
/**
 * @summary Снимки деривативов в окне
 */
const listDerivativesSnapshotsApiMarketDerivativesSnapshotsGet = (
    params: ListDerivativesSnapshotsApiMarketDerivativesSnapshotsGetParams,
 options?: SecondParameter<typeof customInstance<ListDerivativesSnapshotsApiMarketDerivativesSnapshotsGet200>>,) => {
      return customInstance<ListDerivativesSnapshotsApiMarketDerivativesSnapshotsGet200>(
      {url: `/api/market/derivatives-snapshots`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить статус market data service.
 * @summary Get Market Services Status
 */
const getMarketServicesStatusApiMarketServicesStatusGet = (
    
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/services/status`, method: 'GET'
    },
      options);
    }
  
/**
 * Подписаться на рыночные данные по символу.
 * @summary Subscribe Symbol
 */
const subscribeSymbolApiMarketSubscribeSymbolPost = (
    symbol: string,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/subscribe/${symbol}`, method: 'POST'
    },
      options);
    }
  
/**
 * Отписаться от рыночных данных по символу.
 * @summary Unsubscribe Symbol
 */
const unsubscribeSymbolApiMarketUnsubscribeSymbolPost = (
    symbol: string,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/unsubscribe/${symbol}`, method: 'POST'
    },
      options);
    }
  
/**
 * Подписаться на klines для символа и интервала (Binance stream).
В prod бары в чарт идут только из Kafka (Flink → market.bar.v1 → bars-to-WS → WS); этот вызов не влияет на доставку баров в UI.
 * @summary Subscribe Klines
 */
const subscribeKlinesApiMarketSubscribeSymbolKlinesIntervalPost = (
    symbol: string,
    interval: string,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/subscribe/${symbol}/klines/${interval}`, method: 'POST'
    },
      options);
    }
  
/**
 * Отписаться от klines.
 * @summary Unsubscribe Klines
 */
const unsubscribeKlinesApiMarketUnsubscribeSymbolKlinesIntervalPost = (
    symbol: string,
    interval: string,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/unsubscribe/${symbol}/klines/${interval}`, method: 'POST'
    },
      options);
    }
  
/**
 * Получить исторические бары.

SSOT: единственный источник истины - BarPersistencePort.
 * @summary Get Historical Bars
 */
const getHistoricalBarsApiMarketHistorySymbolIntervalGet = (
    symbol: string,
    interval: string,
    params?: GetHistoricalBarsApiMarketHistorySymbolIntervalGetParams,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/history/${symbol}/${interval}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * SSOT лимитов market history для UI и клиентов.
 * @summary Get Market Limits
 */
const getMarketLimitsApiMarketLimitsGet = (
    
 options?: SecondParameter<typeof customInstance<GetMarketLimitsApiMarketLimitsGet200>>,) => {
      return customInstance<GetMarketLimitsApiMarketLimitsGet200>(
      {url: `/api/market/limits`, method: 'GET'
    },
      options);
    }
  
/**
 * История баров (канон API).

С agent_id: symbol, interval и окно (from/to) берутся из definition агента — ограничение по заложенным параметрам.
Без agent_id: передайте symbol, interval; from/to опциональны.
 * @summary Get Historical Bars Query
 */
const getHistoricalBarsQueryApiMarketHistoryGet = (
    params?: GetHistoricalBarsQueryApiMarketHistoryGetParams,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/history`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Enterprise paging для истории (Apache-like):
- курсор `before_ts_ms` (event-time cursor по SSOT `ts_open_ms`)
- страница всегда детерминирована и воспроизводима
- результат отсортирован по `ts_open_ms` ASC
 * @summary Get Bars Page
 */
const getBarsPageApiMarketBarsSymbolIntervalGet = (
    symbol: string,
    interval: string,
    params?: GetBarsPageApiMarketBarsSymbolIntervalGetParams,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/market/bars/${symbol}/${interval}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить снимок состояния рынка.

Возвращает текущие цены и статистику по всем активным символам.
 * @summary Get Market Snapshot
 */
const getMarketSnapshotApiMarketSnapshotGet = (
    
 options?: SecondParameter<typeof customInstance<MarketSnapshot>>,) => {
      return customInstance<MarketSnapshot>(
      {url: `/api/market/snapshot`, method: 'GET'
    },
      options);
    }
  
/**
 * Зарегистрировать интервал для символа. Internal/admin only; UI не вызывает.
 * @summary Register interval (internal)
 */
const registerIntervalApiIntervalsSymbolPost = (
    symbol: string,
    params: RegisterIntervalApiIntervalsSymbolPostParams,
 options?: SecondParameter<typeof customInstance<RegisterIntervalApiIntervalsSymbolPost200>>,) => {
      return customInstance<RegisterIntervalApiIntervalsSymbolPost200>(
      {url: `/api/intervals/${symbol}`, method: 'POST',
        params
    },
      options);
    }
  
/**
 * Получить список интервалов для символа.
 * @summary Get intervals
 */
const getIntervalsApiIntervalsSymbolGet = (
    symbol: string,
 options?: SecondParameter<typeof customInstance<IntervalConfig[]>>,) => {
      return customInstance<IntervalConfig[]>(
      {url: `/api/intervals/${symbol}`, method: 'GET'
    },
      options);
    }
  
/**
 * Отменить регистрацию интервала. Internal/admin only; UI не вызывает.
 * @summary Unregister interval (internal)
 */
const unregisterIntervalApiIntervalsSymbolIntervalIdDelete = (
    symbol: string,
    intervalId: string,
 options?: SecondParameter<typeof customInstance<UnregisterIntervalApiIntervalsSymbolIntervalIdDelete200>>,) => {
      return customInstance<UnregisterIntervalApiIntervalsSymbolIntervalIdDelete200>(
      {url: `/api/intervals/${symbol}/${intervalId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * Получить все интервалы для всех символов.
 * @summary Get all intervals
 */
const getAllIntervalsApiIntervalsGet = (
    
 options?: SecondParameter<typeof customInstance<GetAllIntervalsApiIntervalsGet200>>,) => {
      return customInstance<GetAllIntervalsApiIntervalsGet200>(
      {url: `/api/intervals`, method: 'GET'
    },
      options);
    }
  
/**
 * Канонический Prometheus scrape endpoint для `/api/metrics`.
 * @summary Get Prometheus Metrics
 */
const getPrometheusMetricsApiMetricsGet = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/metrics`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить статистику системы.
 * @summary Get Stats
 */
const getStatsApiMetricsStatsGet = (
    
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/metrics/stats`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить статус всех circuit breakers.
 * @summary Get Circuit Breakers
 */
const getCircuitBreakersApiMetricsCircuitBreakersGet = (
    
 options?: SecondParameter<typeof customInstance<GetCircuitBreakersApiMetricsCircuitBreakersGet200>>,) => {
      return customInstance<GetCircuitBreakersApiMetricsCircuitBreakersGet200>(
      {url: `/api/metrics/circuit-breakers`, method: 'GET'
    },
      options);
    }
  
/**
 * Сбросить circuit breaker.
 * @summary Reset Circuit Breaker
 */
const resetCircuitBreakerApiMetricsCircuitBreakersNameResetPost = (
    name: string,
 options?: SecondParameter<typeof customInstance<ResetCircuitBreakerApiMetricsCircuitBreakersNameResetPost200>>,) => {
      return customInstance<ResetCircuitBreakerApiMetricsCircuitBreakersNameResetPost200>(
      {url: `/api/metrics/circuit-breakers/${name}/reset`, method: 'POST'
    },
      options);
    }
  
/**
 * Получить метрики Binance интеграции.

Включает:
- RPS (requests per second)
- Retries (число повторных попыток)
- Circuit breaker trips (срабатывания CB)
- Reconnects (переподключения)
- Lag (задержки)
- Drop rate (дроп рейт)
 * @summary Get Binance Metrics
 */
const getBinanceMetricsApiMetricsBinanceGet = (
    
 options?: SecondParameter<typeof customInstance<GetBinanceMetricsApiMetricsBinanceGet200>>,) => {
      return customInstance<GetBinanceMetricsApiMetricsBinanceGet200>(
      {url: `/api/metrics/binance`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить метрики Binance в формате Prometheus.

Совместимо с Prometheus scraping.
 * @summary Get Binance Prometheus Metrics
 */
const getBinancePrometheusMetricsApiMetricsBinancePrometheusGet = (
    
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/metrics/binance/prometheus`, method: 'GET'
    },
      options);
    }
  
/**
 * Prometheus метрики для WebSocket компонентов.

Returns:
    Метрики в формате Prometheus
 * @summary Ws Prometheus Metrics
 */
const wsPrometheusMetricsApiMetricsWsGet = (
    
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/metrics/ws`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Список индикаторов
 */
const listIndicatorsApiApiIndicatorsGet = (
    
 options?: SecondParameter<typeof customInstance<IndicatorMetadataResponse[]>>,) => {
      return customInstance<IndicatorMetadataResponse[]>(
      {url: `/api/indicators/`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Реестр индикаторов (ADR-014)
 */
const getRegistryApiIndicatorsRegistryGet = (
    
 options?: SecondParameter<typeof customInstance<IndicatorMetadataResponse[]>>,) => {
      return customInstance<IndicatorMetadataResponse[]>(
      {url: `/api/indicators/registry`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Схема параметров индикатора
 */
const getSchemaApiIndicatorsNameSchemaGet = (
    name: string,
 options?: SecondParameter<typeof customInstance<GetSchemaApiIndicatorsNameSchemaGet200>>,) => {
      return customInstance<GetSchemaApiIndicatorsNameSchemaGet200>(
      {url: `/api/indicators/${name}/schema`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Расчёт индикатора по барам
 */
const calculateIndicatorApiIndicatorsNameCalculatePost = (
    name: string,
    calculateIndicatorRequest: CalculateIndicatorRequest,
 options?: SecondParameter<typeof customInstance<IndicatorCalculationResponse>>,) => {
      return customInstance<IndicatorCalculationResponse>(
      {url: `/api/indicators/${name}/calculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: calculateIndicatorRequest
    },
      options);
    }
  
/**
 * @summary Пакетный расчёт нескольких индикаторов по одним и тем же барам
 */
const calculateIndicatorsBatchApiIndicatorsCalculateBatchPost = (
    calculateIndicatorsBatchRequest: CalculateIndicatorsBatchRequest,
 options?: SecondParameter<typeof customInstance<IndicatorsBatchCalculationResponse>>,) => {
      return customInstance<IndicatorsBatchCalculationResponse>(
      {url: `/api/indicators/calculate-batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: calculateIndicatorsBatchRequest
    },
      options);
    }
  
/**
 * @summary Валидация/эхо параметров индикатора
 */
const updateParamsApiIndicatorsNameParamsPut = (
    name: string,
    updateIndicatorParamsRequest: UpdateIndicatorParamsRequest,
 options?: SecondParameter<typeof customInstance<UpdateParamsApiIndicatorsNameParamsPut200>>,) => {
      return customInstance<UpdateParamsApiIndicatorsNameParamsPut200>(
      {url: `/api/indicators/${name}/params`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateIndicatorParamsRequest
    },
      options);
    }
  
/**
 * @summary Create Indicator Draft
 */
const createIndicatorDraftApiTradingSpecsIndicatorsDraftPost = (
    draftRequestV1: DraftRequestV1,
 options?: SecondParameter<typeof customInstance<DraftResponseV1>>,) => {
      return customInstance<DraftResponseV1>(
      {url: `/api/trading-specs/indicators/draft`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: draftRequestV1
    },
      options);
    }
  
/**
 * @summary Create Strategy Draft
 */
const createStrategyDraftApiTradingSpecsStrategiesDraftPost = (
    draftRequestV1: DraftRequestV1,
 options?: SecondParameter<typeof customInstance<DraftResponseV1>>,) => {
      return customInstance<DraftResponseV1>(
      {url: `/api/trading-specs/strategies/draft`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: draftRequestV1
    },
      options);
    }
  
/**
 * @summary Validate Indicator Spec
 */
const validateIndicatorSpecApiTradingSpecsIndicatorsValidatePost = (
    indicatorSpecV1: IndicatorSpecV1,
 options?: SecondParameter<typeof customInstance<ValidateResponseV1>>,) => {
      return customInstance<ValidateResponseV1>(
      {url: `/api/trading-specs/indicators/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: indicatorSpecV1
    },
      options);
    }
  
/**
 * @summary Validate Strategy Spec
 */
const validateStrategySpecApiTradingSpecsStrategiesValidatePost = (
    strategySpecV1: StrategySpecV1,
 options?: SecondParameter<typeof customInstance<ValidateResponseV1>>,) => {
      return customInstance<ValidateResponseV1>(
      {url: `/api/trading-specs/strategies/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: strategySpecV1
    },
      options);
    }
  
/**
 * @summary Save Indicator Spec
 */
const saveIndicatorSpecApiTradingSpecsIndicatorsPost = (
    indicatorSpecV1: IndicatorSpecV1,
 options?: SecondParameter<typeof customInstance<SaveResponseV1>>,) => {
      return customInstance<SaveResponseV1>(
      {url: `/api/trading-specs/indicators`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: indicatorSpecV1
    },
      options);
    }
  
/**
 * @summary Save Strategy Spec
 */
const saveStrategySpecApiTradingSpecsStrategiesPost = (
    strategySpecV1: StrategySpecV1,
 options?: SecondParameter<typeof customInstance<SaveResponseV1>>,) => {
      return customInstance<SaveResponseV1>(
      {url: `/api/trading-specs/strategies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: strategySpecV1
    },
      options);
    }
  
/**
 * @summary Deprecate Spec Version
 */
const deprecateSpecVersionApiTradingSpecsKindSpecIdVersionDeprecatePost = (
    kind: 'indicator' | 'strategy',
    specId: string,
    version: string,
    deprecateSpecRequestV1: DeprecateSpecRequestV1,
 options?: SecondParameter<typeof customInstance<DeprecateSpecResponseV1>>,) => {
      return customInstance<DeprecateSpecResponseV1>(
      {url: `/api/trading-specs/${kind}/${specId}/${version}/deprecate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: deprecateSpecRequestV1
    },
      options);
    }
  
/**
 * @summary List Spec Versions
 */
const listSpecVersionsApiTradingSpecsKindSpecIdVersionsGet = (
    kind: 'indicator' | 'strategy',
    specId: string,
 options?: SecondParameter<typeof customInstance<VersionsResponseV1>>,) => {
      return customInstance<VersionsResponseV1>(
      {url: `/api/trading-specs/${kind}/${specId}/versions`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get Spec Version
 */
const getSpecVersionApiTradingSpecsKindSpecIdVersionGet = (
    kind: 'indicator' | 'strategy',
    specId: string,
    version: string,
 options?: SecondParameter<typeof customInstance<SpecResponseV1>>,) => {
      return customInstance<SpecResponseV1>(
      {url: `/api/trading-specs/${kind}/${specId}/${version}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get Audit Events
 */
const getAuditEventsApiTradingSpecsKindSpecIdVersionAuditEventsGet = (
    kind: 'indicator' | 'strategy',
    specId: string,
    version: string,
    params?: GetAuditEventsApiTradingSpecsKindSpecIdVersionAuditEventsGetParams,
 options?: SecondParameter<typeof customInstance<AuditEventsResponseV1>>,) => {
      return customInstance<AuditEventsResponseV1>(
      {url: `/api/trading-specs/${kind}/${specId}/${version}/audit-events`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Create indicator spec from just name + code. Metadata extracted automatically.
 * @summary Quick Save Indicator
 */
const quickSaveIndicatorApiTradingSpecsIndicatorsQuickPost = (
    quickSaveRequestV1: QuickSaveRequestV1,
 options?: SecondParameter<typeof customInstance<QuickSaveResponseV1>>,) => {
      return customInstance<QuickSaveResponseV1>(
      {url: `/api/trading-specs/indicators/quick`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: quickSaveRequestV1
    },
      options);
    }
  
/**
 * Create strategy spec from just name + code. Metadata extracted automatically.
 * @summary Quick Save Strategy
 */
const quickSaveStrategyApiTradingSpecsStrategiesQuickPost = (
    quickSaveRequestV1: QuickSaveRequestV1,
 options?: SecondParameter<typeof customInstance<QuickSaveResponseV1>>,) => {
      return customInstance<QuickSaveResponseV1>(
      {url: `/api/trading-specs/strategies/quick`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: quickSaveRequestV1
    },
      options);
    }
  
/**
 * @summary Catalog Indicators
 */
const catalogIndicatorsApiTradingSpecsCatalogIndicatorsGet = (
    params?: CatalogIndicatorsApiTradingSpecsCatalogIndicatorsGetParams,
 options?: SecondParameter<typeof customInstance<CatalogResponseV1>>,) => {
      return customInstance<CatalogResponseV1>(
      {url: `/api/trading-specs/catalog/indicators`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Catalog Strategies
 */
const catalogStrategiesApiTradingSpecsCatalogStrategiesGet = (
    params?: CatalogStrategiesApiTradingSpecsCatalogStrategiesGetParams,
 options?: SecondParameter<typeof customInstance<CatalogResponseV1>>,) => {
      return customInstance<CatalogResponseV1>(
      {url: `/api/trading-specs/catalog/strategies`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Resolve Strategy
 */
const resolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGet = (
    specId: string,
    version: string,
    params?: ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetParams,
 options?: SecondParameter<typeof customInstance<ResolvedStrategyResponseV1>>,) => {
      return customInstance<ResolvedStrategyResponseV1>(
      {url: `/api/trading-specs/strategies/${specId}/${version}/resolved`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Aggregated spec health counters for dashboards.
 * @summary Trading Specs Dashboard Health
 */
const tradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGet = (
    
 options?: SecondParameter<typeof customInstance<TradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGet200>>,) => {
      return customInstance<TradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGet200>(
      {url: `/api/trading-specs/dashboard/health`, method: 'GET'
    },
      options);
    }
  
/**
 * Lightweight readiness probe for UI (no OpenAI call).
 * @summary Get Ai Status
 */
const getAiStatusApiTradingSpecsAiStatusGet = (
    
 options?: SecondParameter<typeof customInstance<AiStatusResponseV1>>,) => {
      return customInstance<AiStatusResponseV1>(
      {url: `/api/trading-specs/ai/status`, method: 'GET'
    },
      options);
    }
  
/**
 * Return AI contract and prompt template for the given kind.
 * @summary Get Ai Contracts
 */
const getAiContractsApiTradingSpecsAiContractsGet = (
    params: GetAiContractsApiTradingSpecsAiContractsGetParams,
 options?: SecondParameter<typeof customInstance<AiContractResponseV1>>,) => {
      return customInstance<AiContractResponseV1>(
      {url: `/api/trading-specs/ai/contracts`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create Ai Session
 */
const createAiSessionApiTradingSpecsAiSessionsPost = (
    aiChatSessionCreateRequestV1: AiChatSessionCreateRequestV1,
 options?: SecondParameter<typeof customInstance<AiChatSessionResponseV1>>,) => {
      return customInstance<AiChatSessionResponseV1>(
      {url: `/api/trading-specs/ai/sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiChatSessionCreateRequestV1
    },
      options);
    }
  
/**
 * @summary Get Ai Session
 */
const getAiSessionApiTradingSpecsAiSessionsSessionIdGet = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance<AiChatSessionResponseV1>>,) => {
      return customInstance<AiChatSessionResponseV1>(
      {url: `/api/trading-specs/ai/sessions/${sessionId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Send Ai Message
 */
const sendAiMessageApiTradingSpecsAiSessionsSessionIdMessagesPost = (
    sessionId: string,
    aiChatMessageCreateRequestV1: AiChatMessageCreateRequestV1,
 options?: SecondParameter<typeof customInstance<AiChatMessageResponseV1>>,) => {
      return customInstance<AiChatMessageResponseV1>(
      {url: `/api/trading-specs/ai/sessions/${sessionId}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiChatMessageCreateRequestV1
    },
      options);
    }
  
/**
 * @summary Validate Ai Artifact
 */
const validateAiArtifactApiTradingSpecsAiArtifactsArtifactIdValidatePost = (
    artifactId: string,
 options?: SecondParameter<typeof customInstance<AiPublishArtifactResponseV1>>,) => {
      return customInstance<AiPublishArtifactResponseV1>(
      {url: `/api/trading-specs/ai/artifacts/${artifactId}/validate`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary Publish Ai Artifact
 */
const publishAiArtifactApiTradingSpecsAiArtifactsArtifactIdPublishPost = (
    artifactId: string,
    aiPublishArtifactRequestV1: AiPublishArtifactRequestV1,
 options?: SecondParameter<typeof customInstance<AiPublishArtifactResponseV1>>,) => {
      return customInstance<AiPublishArtifactResponseV1>(
      {url: `/api/trading-specs/ai/artifacts/${artifactId}/publish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiPublishArtifactRequestV1
    },
      options);
    }
  
/**
 * Сводная статистика по агенту на основе БД.

При переданном side=BUY/SELL статистика считается по сделкам соответствующей стороны
через порт `TradePersistencePort.get_aggregated_stats_by_side`, иначе используется агрегат
через `StatsPersistencePort.get_aggregated_stats`.
 * @summary Get Statistics Summary
 */
const getStatisticsSummaryApiStatsSummaryGet = (
    params: GetStatisticsSummaryApiStatsSummaryGetParams,
 options?: SecondParameter<typeof customInstance<AgentSummary>>,) => {
      return customInstance<AgentSummary>(
      {url: `/api/stats/summary`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Экспорт ордеров/сделок агента из БД (через порт, без импорта моделей БД).
 * @summary Export Trades
 */
const exportTradesApiStatsExportGet = (
    params: ExportTradesApiStatsExportGetParams,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/stats/export`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Данные производительности по AgentStats для графиков.
 * @summary Get Performance Data
 */
const getPerformanceDataApiStatsPerformanceGet = (
    params: GetPerformanceDataApiStatsPerformanceGetParams,
 options?: SecondParameter<typeof customInstance<PerformanceData[]>>,) => {
      return customInstance<PerformanceData[]>(
      {url: `/api/stats/performance`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить общий обзор метрик WebSocket.
 * @summary Get Metrics Overview
 */
const getMetricsOverviewApiWsMetricsOverviewGet = (
    
 options?: SecondParameter<typeof customInstance<GetMetricsOverviewApiWsMetricsOverviewGet200>>,) => {
      return customInstance<GetMetricsOverviewApiWsMetricsOverviewGet200>(
      {url: `/api/ws/metrics/overview`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить метрики конкретного канала.
 * @summary Get Channel Metrics
 */
const getChannelMetricsApiWsMetricsChannelsChannelGet = (
    channel: string,
 options?: SecondParameter<typeof customInstance<GetChannelMetricsApiWsMetricsChannelsChannelGet200>>,) => {
      return customInstance<GetChannelMetricsApiWsMetricsChannelsChannelGet200>(
      {url: `/api/ws/metrics/channels/${channel}`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить метрики конкретного соединения.
 * @summary Get Connection Metrics
 */
const getConnectionMetricsApiWsMetricsConnectionsWsIdGet = (
    wsId: string,
 options?: SecondParameter<typeof customInstance<GetConnectionMetricsApiWsMetricsConnectionsWsIdGet200>>,) => {
      return customInstance<GetConnectionMetricsApiWsMetricsConnectionsWsIdGet200>(
      {url: `/api/ws/metrics/connections/${wsId}`, method: 'GET'
    },
      options);
    }
  
/**
 * Получить список всех каналов с метриками.
 * @summary List Channels
 */
const listChannelsApiWsMetricsChannelsGet = (
    params?: ListChannelsApiWsMetricsChannelsGetParams,
 options?: SecondParameter<typeof customInstance<ListChannelsApiWsMetricsChannelsGet200>>,) => {
      return customInstance<ListChannelsApiWsMetricsChannelsGet200>(
      {url: `/api/ws/metrics/channels`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить список активных соединений.
 * @summary List Connections
 */
const listConnectionsApiWsMetricsConnectionsGet = (
    params?: ListConnectionsApiWsMetricsConnectionsGetParams,
 options?: SecondParameter<typeof customInstance<ListConnectionsApiWsMetricsConnectionsGet200>>,) => {
      return customInstance<ListConnectionsApiWsMetricsConnectionsGet200>(
      {url: `/api/ws/metrics/connections`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Получить последние алерты. При недоступности Alertmanager возвращает 200 с status=unavailable.
 * @summary Get Alerts
 */
const getAlertsApiWsMetricsAlertsGet = (
    params?: GetAlertsApiWsMetricsAlertsGetParams,
 options?: SecondParameter<typeof customInstance<GetAlertsApiWsMetricsAlertsGet200>>,) => {
      return customInstance<GetAlertsApiWsMetricsAlertsGet200>(
      {url: `/api/ws/metrics/alerts`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * "Очистить" алерты через Alertmanager (silence на 5 мин).
При недоступности Alertmanager возвращает 200 с status=disabled.
 * @summary Clear Alerts
 */
const clearAlertsApiWsMetricsAlertsClearPost = (
    
 options?: SecondParameter<typeof customInstance<ClearAlertsApiWsMetricsAlertsClearPost200>>,) => {
      return customInstance<ClearAlertsApiWsMetricsAlertsClearPost200>(
      {url: `/api/ws/metrics/alerts/clear`, method: 'POST'
    },
      options);
    }
  
/**
 * Получить статистику WebSocket.
 * @summary Get Stats
 */
const getStatsApiWsMetricsStatsGet = (
    
 options?: SecondParameter<typeof customInstance<GetStatsApiWsMetricsStatsGet200>>,) => {
      return customInstance<GetStatsApiWsMetricsStatsGet200>(
      {url: `/api/ws/metrics/stats`, method: 'GET'
    },
      options);
    }
  
return {healthCheckApiHealthHealthzGet,readinessCheckApiHealthReadyzGet,getSystemResourcesApiHealthSystemResourcesGet,getStreamHealthApiHealthHealthStreamGet,getLakeHealthApiHealthHealthLakeGet,getLakeHealthApiHealthLakeGet,getLakeRetentionPlanApiHealthHealthLakeRetentionPlanGet,getLakeRetentionPlanApiHealthLakeRetentionPlanGet,getCoverageLedgerApiHealthCoverageLedgerGet,getAgentDefinitionApiAgentsAgentIdDefinitionGet,patchAgentDefinitionApiAgentsAgentIdDefinitionPatch,strategyPreflightApiAgentsStrategyPreflightPost,listAgentsApiAgentsGet,createAgentApiAgentsPost,getAgentApiAgentsAgentIdGet,deleteAgentApiAgentsAgentIdDelete,getAgentStrategyConfigApiAgentsAgentIdStrategyConfigGet,patchAgentStrategyConfigApiAgentsAgentIdStrategyConfigPatch,getAgentRuntimeStateApiAgentsAgentIdRuntimeStateGet,getAgentBackfillStatusApiAgentsAgentIdBackfillStatusGet,startAgentApiAgentsAgentIdStartPost,stopAgentApiAgentsAgentIdStopPost,runBacktestApiBacktestPost,listBacktestsApiBacktestGet,getBacktestResultApiBacktestBacktestIdGet,cancelBacktestApiBacktestBacktestIdDelete,getBacktestProgressApiBacktestBacktestIdProgressGet,getBacktestTradesApiBacktestBacktestIdTradesGet,getBacktestMetricsApiBacktestBacktestIdMetricsGet,optimizeBacktestApiBacktestOptimizePost,listOptimizationsApiBacktestOptimizeGet,getOptimizationProgressApiBacktestOptimizeOptimizationIdProgressGet,getOptimizationApiBacktestOptimizeOptimizationIdGet,compareOptimizationsApiBacktestOptimizeComparePost,optimizationLeaderboardApiBacktestOptimizeLeaderboardGet,getTradesApiTradesGet,getRuntimeProjectionApiTradesRuntimeGet,persistFillApiTradesFillPost,getSignalsApiSignalsGet,getActiveSignalsApiSignalsAgentIdActiveGet,getBrokerTypesApiBrokersTypesGet,createBrokerApiBrokersCreatePost,listBrokersApiBrokersListGet,getBrokerApiBrokersBrokerIdGet,placeOrderApiBrokersAgentIdOrderPost,cancelOrderApiBrokersAgentIdOrderDelete,getOrdersApiBrokersAgentIdOrdersGet,getPositionsApiBrokersAgentIdPositionsGet,getAccountInfoApiBrokersAgentIdAccountGet,setLeverageApiBrokersAgentIdLeveragePost,setMarginTypeApiBrokersAgentIdMarginTypePost,getMarketDataApiMarketDataSymbolGet,buildChartProjectionApiMarketChartProjectionPost,buildChartFactsApiMarketChartFactsPost,ingestMarketCalendarEventApiMarketCalendarEventsIngestPost,listMarketCalendarEventsApiMarketCalendarEventsGet,ingestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPost,listDerivativesSnapshotsApiMarketDerivativesSnapshotsGet,getMarketServicesStatusApiMarketServicesStatusGet,subscribeSymbolApiMarketSubscribeSymbolPost,unsubscribeSymbolApiMarketUnsubscribeSymbolPost,subscribeKlinesApiMarketSubscribeSymbolKlinesIntervalPost,unsubscribeKlinesApiMarketUnsubscribeSymbolKlinesIntervalPost,getHistoricalBarsApiMarketHistorySymbolIntervalGet,getMarketLimitsApiMarketLimitsGet,getHistoricalBarsQueryApiMarketHistoryGet,getBarsPageApiMarketBarsSymbolIntervalGet,getMarketSnapshotApiMarketSnapshotGet,registerIntervalApiIntervalsSymbolPost,getIntervalsApiIntervalsSymbolGet,unregisterIntervalApiIntervalsSymbolIntervalIdDelete,getAllIntervalsApiIntervalsGet,getPrometheusMetricsApiMetricsGet,getStatsApiMetricsStatsGet,getCircuitBreakersApiMetricsCircuitBreakersGet,resetCircuitBreakerApiMetricsCircuitBreakersNameResetPost,getBinanceMetricsApiMetricsBinanceGet,getBinancePrometheusMetricsApiMetricsBinancePrometheusGet,wsPrometheusMetricsApiMetricsWsGet,listIndicatorsApiApiIndicatorsGet,getRegistryApiIndicatorsRegistryGet,getSchemaApiIndicatorsNameSchemaGet,calculateIndicatorApiIndicatorsNameCalculatePost,calculateIndicatorsBatchApiIndicatorsCalculateBatchPost,updateParamsApiIndicatorsNameParamsPut,createIndicatorDraftApiTradingSpecsIndicatorsDraftPost,createStrategyDraftApiTradingSpecsStrategiesDraftPost,validateIndicatorSpecApiTradingSpecsIndicatorsValidatePost,validateStrategySpecApiTradingSpecsStrategiesValidatePost,saveIndicatorSpecApiTradingSpecsIndicatorsPost,saveStrategySpecApiTradingSpecsStrategiesPost,deprecateSpecVersionApiTradingSpecsKindSpecIdVersionDeprecatePost,listSpecVersionsApiTradingSpecsKindSpecIdVersionsGet,getSpecVersionApiTradingSpecsKindSpecIdVersionGet,getAuditEventsApiTradingSpecsKindSpecIdVersionAuditEventsGet,quickSaveIndicatorApiTradingSpecsIndicatorsQuickPost,quickSaveStrategyApiTradingSpecsStrategiesQuickPost,catalogIndicatorsApiTradingSpecsCatalogIndicatorsGet,catalogStrategiesApiTradingSpecsCatalogStrategiesGet,resolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGet,tradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGet,getAiStatusApiTradingSpecsAiStatusGet,getAiContractsApiTradingSpecsAiContractsGet,createAiSessionApiTradingSpecsAiSessionsPost,getAiSessionApiTradingSpecsAiSessionsSessionIdGet,sendAiMessageApiTradingSpecsAiSessionsSessionIdMessagesPost,validateAiArtifactApiTradingSpecsAiArtifactsArtifactIdValidatePost,publishAiArtifactApiTradingSpecsAiArtifactsArtifactIdPublishPost,getStatisticsSummaryApiStatsSummaryGet,exportTradesApiStatsExportGet,getPerformanceDataApiStatsPerformanceGet,getMetricsOverviewApiWsMetricsOverviewGet,getChannelMetricsApiWsMetricsChannelsChannelGet,getConnectionMetricsApiWsMetricsConnectionsWsIdGet,listChannelsApiWsMetricsChannelsGet,listConnectionsApiWsMetricsConnectionsGet,getAlertsApiWsMetricsAlertsGet,clearAlertsApiWsMetricsAlertsClearPost,getStatsApiWsMetricsStatsGet}};
export type HealthCheckApiHealthHealthzGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['healthCheckApiHealthHealthzGet']>>>
export type ReadinessCheckApiHealthReadyzGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['readinessCheckApiHealthReadyzGet']>>>
export type GetSystemResourcesApiHealthSystemResourcesGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getSystemResourcesApiHealthSystemResourcesGet']>>>
export type GetStreamHealthApiHealthHealthStreamGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getStreamHealthApiHealthHealthStreamGet']>>>
export type GetLakeHealthApiHealthHealthLakeGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getLakeHealthApiHealthHealthLakeGet']>>>
export type GetLakeHealthApiHealthLakeGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getLakeHealthApiHealthLakeGet']>>>
export type GetLakeRetentionPlanApiHealthHealthLakeRetentionPlanGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getLakeRetentionPlanApiHealthHealthLakeRetentionPlanGet']>>>
export type GetLakeRetentionPlanApiHealthLakeRetentionPlanGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getLakeRetentionPlanApiHealthLakeRetentionPlanGet']>>>
export type GetCoverageLedgerApiHealthCoverageLedgerGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getCoverageLedgerApiHealthCoverageLedgerGet']>>>
export type GetAgentDefinitionApiAgentsAgentIdDefinitionGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAgentDefinitionApiAgentsAgentIdDefinitionGet']>>>
export type PatchAgentDefinitionApiAgentsAgentIdDefinitionPatchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['patchAgentDefinitionApiAgentsAgentIdDefinitionPatch']>>>
export type StrategyPreflightApiAgentsStrategyPreflightPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['strategyPreflightApiAgentsStrategyPreflightPost']>>>
export type ListAgentsApiAgentsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listAgentsApiAgentsGet']>>>
export type CreateAgentApiAgentsPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['createAgentApiAgentsPost']>>>
export type GetAgentApiAgentsAgentIdGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAgentApiAgentsAgentIdGet']>>>
export type DeleteAgentApiAgentsAgentIdDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['deleteAgentApiAgentsAgentIdDelete']>>>
export type GetAgentStrategyConfigApiAgentsAgentIdStrategyConfigGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAgentStrategyConfigApiAgentsAgentIdStrategyConfigGet']>>>
export type PatchAgentStrategyConfigApiAgentsAgentIdStrategyConfigPatchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['patchAgentStrategyConfigApiAgentsAgentIdStrategyConfigPatch']>>>
export type GetAgentRuntimeStateApiAgentsAgentIdRuntimeStateGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAgentRuntimeStateApiAgentsAgentIdRuntimeStateGet']>>>
export type GetAgentBackfillStatusApiAgentsAgentIdBackfillStatusGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAgentBackfillStatusApiAgentsAgentIdBackfillStatusGet']>>>
export type StartAgentApiAgentsAgentIdStartPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['startAgentApiAgentsAgentIdStartPost']>>>
export type StopAgentApiAgentsAgentIdStopPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['stopAgentApiAgentsAgentIdStopPost']>>>
export type RunBacktestApiBacktestPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['runBacktestApiBacktestPost']>>>
export type ListBacktestsApiBacktestGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listBacktestsApiBacktestGet']>>>
export type GetBacktestResultApiBacktestBacktestIdGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBacktestResultApiBacktestBacktestIdGet']>>>
export type CancelBacktestApiBacktestBacktestIdDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['cancelBacktestApiBacktestBacktestIdDelete']>>>
export type GetBacktestProgressApiBacktestBacktestIdProgressGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBacktestProgressApiBacktestBacktestIdProgressGet']>>>
export type GetBacktestTradesApiBacktestBacktestIdTradesGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBacktestTradesApiBacktestBacktestIdTradesGet']>>>
export type GetBacktestMetricsApiBacktestBacktestIdMetricsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBacktestMetricsApiBacktestBacktestIdMetricsGet']>>>
export type OptimizeBacktestApiBacktestOptimizePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['optimizeBacktestApiBacktestOptimizePost']>>>
export type ListOptimizationsApiBacktestOptimizeGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listOptimizationsApiBacktestOptimizeGet']>>>
export type GetOptimizationProgressApiBacktestOptimizeOptimizationIdProgressGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getOptimizationProgressApiBacktestOptimizeOptimizationIdProgressGet']>>>
export type GetOptimizationApiBacktestOptimizeOptimizationIdGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getOptimizationApiBacktestOptimizeOptimizationIdGet']>>>
export type CompareOptimizationsApiBacktestOptimizeComparePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['compareOptimizationsApiBacktestOptimizeComparePost']>>>
export type OptimizationLeaderboardApiBacktestOptimizeLeaderboardGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['optimizationLeaderboardApiBacktestOptimizeLeaderboardGet']>>>
export type GetTradesApiTradesGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getTradesApiTradesGet']>>>
export type GetRuntimeProjectionApiTradesRuntimeGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getRuntimeProjectionApiTradesRuntimeGet']>>>
export type PersistFillApiTradesFillPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['persistFillApiTradesFillPost']>>>
export type GetSignalsApiSignalsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getSignalsApiSignalsGet']>>>
export type GetActiveSignalsApiSignalsAgentIdActiveGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getActiveSignalsApiSignalsAgentIdActiveGet']>>>
export type GetBrokerTypesApiBrokersTypesGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBrokerTypesApiBrokersTypesGet']>>>
export type CreateBrokerApiBrokersCreatePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['createBrokerApiBrokersCreatePost']>>>
export type ListBrokersApiBrokersListGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listBrokersApiBrokersListGet']>>>
export type GetBrokerApiBrokersBrokerIdGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBrokerApiBrokersBrokerIdGet']>>>
export type PlaceOrderApiBrokersAgentIdOrderPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['placeOrderApiBrokersAgentIdOrderPost']>>>
export type CancelOrderApiBrokersAgentIdOrderDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['cancelOrderApiBrokersAgentIdOrderDelete']>>>
export type GetOrdersApiBrokersAgentIdOrdersGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getOrdersApiBrokersAgentIdOrdersGet']>>>
export type GetPositionsApiBrokersAgentIdPositionsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getPositionsApiBrokersAgentIdPositionsGet']>>>
export type GetAccountInfoApiBrokersAgentIdAccountGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAccountInfoApiBrokersAgentIdAccountGet']>>>
export type SetLeverageApiBrokersAgentIdLeveragePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['setLeverageApiBrokersAgentIdLeveragePost']>>>
export type SetMarginTypeApiBrokersAgentIdMarginTypePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['setMarginTypeApiBrokersAgentIdMarginTypePost']>>>
export type GetMarketDataApiMarketDataSymbolGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getMarketDataApiMarketDataSymbolGet']>>>
export type BuildChartProjectionApiMarketChartProjectionPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['buildChartProjectionApiMarketChartProjectionPost']>>>
export type BuildChartFactsApiMarketChartFactsPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['buildChartFactsApiMarketChartFactsPost']>>>
export type IngestMarketCalendarEventApiMarketCalendarEventsIngestPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['ingestMarketCalendarEventApiMarketCalendarEventsIngestPost']>>>
export type ListMarketCalendarEventsApiMarketCalendarEventsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listMarketCalendarEventsApiMarketCalendarEventsGet']>>>
export type IngestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['ingestDerivativesSnapshotRouteApiMarketDerivativesSnapshotsIngestPost']>>>
export type ListDerivativesSnapshotsApiMarketDerivativesSnapshotsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listDerivativesSnapshotsApiMarketDerivativesSnapshotsGet']>>>
export type GetMarketServicesStatusApiMarketServicesStatusGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getMarketServicesStatusApiMarketServicesStatusGet']>>>
export type SubscribeSymbolApiMarketSubscribeSymbolPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['subscribeSymbolApiMarketSubscribeSymbolPost']>>>
export type UnsubscribeSymbolApiMarketUnsubscribeSymbolPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['unsubscribeSymbolApiMarketUnsubscribeSymbolPost']>>>
export type SubscribeKlinesApiMarketSubscribeSymbolKlinesIntervalPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['subscribeKlinesApiMarketSubscribeSymbolKlinesIntervalPost']>>>
export type UnsubscribeKlinesApiMarketUnsubscribeSymbolKlinesIntervalPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['unsubscribeKlinesApiMarketUnsubscribeSymbolKlinesIntervalPost']>>>
export type GetHistoricalBarsApiMarketHistorySymbolIntervalGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getHistoricalBarsApiMarketHistorySymbolIntervalGet']>>>
export type GetMarketLimitsApiMarketLimitsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getMarketLimitsApiMarketLimitsGet']>>>
export type GetHistoricalBarsQueryApiMarketHistoryGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getHistoricalBarsQueryApiMarketHistoryGet']>>>
export type GetBarsPageApiMarketBarsSymbolIntervalGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBarsPageApiMarketBarsSymbolIntervalGet']>>>
export type GetMarketSnapshotApiMarketSnapshotGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getMarketSnapshotApiMarketSnapshotGet']>>>
export type RegisterIntervalApiIntervalsSymbolPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['registerIntervalApiIntervalsSymbolPost']>>>
export type GetIntervalsApiIntervalsSymbolGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getIntervalsApiIntervalsSymbolGet']>>>
export type UnregisterIntervalApiIntervalsSymbolIntervalIdDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['unregisterIntervalApiIntervalsSymbolIntervalIdDelete']>>>
export type GetAllIntervalsApiIntervalsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAllIntervalsApiIntervalsGet']>>>
export type GetPrometheusMetricsApiMetricsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getPrometheusMetricsApiMetricsGet']>>>
export type GetStatsApiMetricsStatsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getStatsApiMetricsStatsGet']>>>
export type GetCircuitBreakersApiMetricsCircuitBreakersGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getCircuitBreakersApiMetricsCircuitBreakersGet']>>>
export type ResetCircuitBreakerApiMetricsCircuitBreakersNameResetPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['resetCircuitBreakerApiMetricsCircuitBreakersNameResetPost']>>>
export type GetBinanceMetricsApiMetricsBinanceGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBinanceMetricsApiMetricsBinanceGet']>>>
export type GetBinancePrometheusMetricsApiMetricsBinancePrometheusGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getBinancePrometheusMetricsApiMetricsBinancePrometheusGet']>>>
export type WsPrometheusMetricsApiMetricsWsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['wsPrometheusMetricsApiMetricsWsGet']>>>
export type ListIndicatorsApiApiIndicatorsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listIndicatorsApiApiIndicatorsGet']>>>
export type GetRegistryApiIndicatorsRegistryGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getRegistryApiIndicatorsRegistryGet']>>>
export type GetSchemaApiIndicatorsNameSchemaGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getSchemaApiIndicatorsNameSchemaGet']>>>
export type CalculateIndicatorApiIndicatorsNameCalculatePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['calculateIndicatorApiIndicatorsNameCalculatePost']>>>
export type CalculateIndicatorsBatchApiIndicatorsCalculateBatchPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['calculateIndicatorsBatchApiIndicatorsCalculateBatchPost']>>>
export type UpdateParamsApiIndicatorsNameParamsPutResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['updateParamsApiIndicatorsNameParamsPut']>>>
export type CreateIndicatorDraftApiTradingSpecsIndicatorsDraftPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['createIndicatorDraftApiTradingSpecsIndicatorsDraftPost']>>>
export type CreateStrategyDraftApiTradingSpecsStrategiesDraftPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['createStrategyDraftApiTradingSpecsStrategiesDraftPost']>>>
export type ValidateIndicatorSpecApiTradingSpecsIndicatorsValidatePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['validateIndicatorSpecApiTradingSpecsIndicatorsValidatePost']>>>
export type ValidateStrategySpecApiTradingSpecsStrategiesValidatePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['validateStrategySpecApiTradingSpecsStrategiesValidatePost']>>>
export type SaveIndicatorSpecApiTradingSpecsIndicatorsPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['saveIndicatorSpecApiTradingSpecsIndicatorsPost']>>>
export type SaveStrategySpecApiTradingSpecsStrategiesPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['saveStrategySpecApiTradingSpecsStrategiesPost']>>>
export type DeprecateSpecVersionApiTradingSpecsKindSpecIdVersionDeprecatePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['deprecateSpecVersionApiTradingSpecsKindSpecIdVersionDeprecatePost']>>>
export type ListSpecVersionsApiTradingSpecsKindSpecIdVersionsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listSpecVersionsApiTradingSpecsKindSpecIdVersionsGet']>>>
export type GetSpecVersionApiTradingSpecsKindSpecIdVersionGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getSpecVersionApiTradingSpecsKindSpecIdVersionGet']>>>
export type GetAuditEventsApiTradingSpecsKindSpecIdVersionAuditEventsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAuditEventsApiTradingSpecsKindSpecIdVersionAuditEventsGet']>>>
export type QuickSaveIndicatorApiTradingSpecsIndicatorsQuickPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['quickSaveIndicatorApiTradingSpecsIndicatorsQuickPost']>>>
export type QuickSaveStrategyApiTradingSpecsStrategiesQuickPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['quickSaveStrategyApiTradingSpecsStrategiesQuickPost']>>>
export type CatalogIndicatorsApiTradingSpecsCatalogIndicatorsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['catalogIndicatorsApiTradingSpecsCatalogIndicatorsGet']>>>
export type CatalogStrategiesApiTradingSpecsCatalogStrategiesGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['catalogStrategiesApiTradingSpecsCatalogStrategiesGet']>>>
export type ResolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['resolveStrategyApiTradingSpecsStrategiesSpecIdVersionResolvedGet']>>>
export type TradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['tradingSpecsDashboardHealthApiTradingSpecsDashboardHealthGet']>>>
export type GetAiStatusApiTradingSpecsAiStatusGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAiStatusApiTradingSpecsAiStatusGet']>>>
export type GetAiContractsApiTradingSpecsAiContractsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAiContractsApiTradingSpecsAiContractsGet']>>>
export type CreateAiSessionApiTradingSpecsAiSessionsPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['createAiSessionApiTradingSpecsAiSessionsPost']>>>
export type GetAiSessionApiTradingSpecsAiSessionsSessionIdGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAiSessionApiTradingSpecsAiSessionsSessionIdGet']>>>
export type SendAiMessageApiTradingSpecsAiSessionsSessionIdMessagesPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['sendAiMessageApiTradingSpecsAiSessionsSessionIdMessagesPost']>>>
export type ValidateAiArtifactApiTradingSpecsAiArtifactsArtifactIdValidatePostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['validateAiArtifactApiTradingSpecsAiArtifactsArtifactIdValidatePost']>>>
export type PublishAiArtifactApiTradingSpecsAiArtifactsArtifactIdPublishPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['publishAiArtifactApiTradingSpecsAiArtifactsArtifactIdPublishPost']>>>
export type GetStatisticsSummaryApiStatsSummaryGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getStatisticsSummaryApiStatsSummaryGet']>>>
export type ExportTradesApiStatsExportGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['exportTradesApiStatsExportGet']>>>
export type GetPerformanceDataApiStatsPerformanceGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getPerformanceDataApiStatsPerformanceGet']>>>
export type GetMetricsOverviewApiWsMetricsOverviewGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getMetricsOverviewApiWsMetricsOverviewGet']>>>
export type GetChannelMetricsApiWsMetricsChannelsChannelGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getChannelMetricsApiWsMetricsChannelsChannelGet']>>>
export type GetConnectionMetricsApiWsMetricsConnectionsWsIdGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getConnectionMetricsApiWsMetricsConnectionsWsIdGet']>>>
export type ListChannelsApiWsMetricsChannelsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listChannelsApiWsMetricsChannelsGet']>>>
export type ListConnectionsApiWsMetricsConnectionsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['listConnectionsApiWsMetricsConnectionsGet']>>>
export type GetAlertsApiWsMetricsAlertsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getAlertsApiWsMetricsAlertsGet']>>>
export type ClearAlertsApiWsMetricsAlertsClearPostResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['clearAlertsApiWsMetricsAlertsClearPost']>>>
export type GetStatsApiWsMetricsStatsGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAlgoSysAPI>['getStatsApiWsMetricsStatsGet']>>>
